import React, { useEffect, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL } from "../../../config/axios";
import axios from "axios";
import Select from "react-select";

import { calculateTotal, CSSForSelect, CSSForSelect15vWWidth, CSSForSelect23vWWidth, CSSForSelectModern, CSSForSelectModern10VWWidth, CSSForSelectModern15VWWidth, formatCurrencyIndian, formatRoundoff, getMonthName, handleErrorToast, isMoreThan24Hours, ProgressModal, sortProjects } from "../../CustomFunctions";
import { Modal } from "react-bootstrap";
import { AddwithBlueCircle, AddwithWhiteCircle } from "../../AllSvg";
import { DeleteTransportationInvoice, UpdateTransportationInvoice } from "./ConsultancyInvoiceComponents";
import usePermission from "../../../config/permissions";
import { DeletePaymentrecipt } from "../ProjectDetailsCrudButtons";
import { formatDateDD_MM_YYYY } from "../../Date";
import { Banknote, Book, BookAlert, Building, Building2Icon, Calendar, FileText, Loader, LucideIdCard, PercentCircle, Plus, PlusCircle, PlusCircleIcon, Save, Tag, TagIcon, UploadIcon, Wallet, X } from "lucide-react";
import { useNavigate } from "react-router-dom";


const AddPaymentReceipt = ({
    p_id,
    invoice_id,
    getPayment,
    month,
    year,
    getVehicle,
    invoice_num,
    consultantInvoiceData,
    calculateCurrentAmountSub,
    calculateCurrentAmountSupport,
    releaseByProject,
    invoiceData,
    project_id,
    calculateTotalEmployee,
    calculateTotaltransport,
    calculateTotalDuty,
    calculateTotalRent,
    calculateTotalSupplies,
    calculatetotalFurniture,
    calculateTotalReports,
    calculateTotalSurevy,
    calculateCurrentAmountSupportDeductions,
    calculateCurrentAmountSubDeductions,
    calculateTotalEmployeeDeductions,
    calculateTotaltransportDeductions,
    calculateTotalDutyDeductions,
    calculateTotalRentDeductions,
    calculateTotalSuppliesDeductions,
    calculateTotalReportsDeductions,
    calculatetotalFurnitureDeductions,
    calculateTotalSurevyDeductions,

}) => {



    const [totalPreviousMonthAmt, setTotalPreviousMonthAmt] = useState(0);
    const [totalPreviousYearAmt, setTotalPreviousYearAmt] = useState(0);
    const [totalDeductionAmt, setTotalDeductionAmt] = useState(0);
    const [withheldReleaseAmt, setwithheldReleaseAmt] = useState(0);
    const [totalWithhelDeductionAmt, settotalWithhelDeductionAmt] = useState(0);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [success, setSuccess] = useState(false)

    const [projectbyid, setprojectbyid] = useState({});

    const [show, setShow] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const fileInputRefs = useRef([]);
    const [invoiceList, setInvoiceList] = useState([]);

    const [previousMonthReleaseData, setPReviousMonthreleaseData] = useState([]);
    const [PreviousYearReleaseData, setPreviousYearReleaseData] = useState([]);
    const [deductionData, setDeductionData] = useState([]);
    const [WithheldRelease, setWithheldRelease] = useState([]);
    const [WithheldDeductionData, setWithheldDeductionData] = useState([]);
    const handleShow = () => {
        setShow(true);
        getProjects();
    }



    console.log("previousMonthReleaseData", previousMonthReleaseData)

    const [deductionRelease, setDeductionRelease] = useState([{
        deduction_id: "",
        withheld_release_amount: "",
        release_month: "",
    }]);

    const getProjectById = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/project/${p_id ? p_id : project_id}/`);
            setprojectbyid(response.data);
        } catch (error) {
            console.error("Error fetching project by ID:", error);
            handleErrorToast(error);
        }
    };

    useEffect(() => {
        getProjectById();
    }, [p_id, project_id, show]);


    const [deductionList, setDeductionList] = useState([]);
    const [selectInvoice, setSelectInvoice] = useState("null");
    const [selectDeduction, setSelectDeduction] = useState("null");

    const getDeductions = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/null/${invoice_id}/null/`);
            setDeductionList(res.data);
        } catch (error) {

        }
    }

    useEffect(() => {
        getDeductions();
    }, [invoice_id]);




    const handlePreviousmonthInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedRow = {
            ...previousMonthReleaseData[index],
            [name]: value,
        };

        // ✅ Declare matched at the top level so it's accessible everywhere below
        const matched = deductionInvoices.find(
            (item) => item.id === (name === "deduction_id" ? value : updatedRow.deduction_id)
        );

        if (updatedRow.deduction_type === "deduction" && name === "deduction_id") {
            updatedRow.deduction_amount = matched?.deduction_amount || 0;
            const release_month = Number(matched?.deduction_month).toFixed(2) || 0;
            updatedRow.release_month = (release_month);

        }
        else if (updatedRow.deduction_type === "withheldDeduction" && name === "deduction_id") {
            updatedRow.withheld_release_amount = matched?.withheld_deduction_amount || 0;
        }

        setPReviousMonthreleaseData((prevFormData) => {
            const newFields = [...prevFormData];
            newFields[index] = updatedRow;
            return newFields;
        });

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };

            if (value.trim() !== "") {
                delete newErrors[`${index}-${name}`];
            }

            if (updatedRow.deduction_type === "deduction" && name === "deduction_amount") {
                const maxAllowed = Number(matched?.deduction_amount) || 0; // ✅ matched is accessible now
                const enteredValue = Number(value) || 0;

                if (enteredValue > maxAllowed) {
                    newErrors[`${index}-${name}`] = `Amount cannot exceed deduction limit of ${maxAllowed}`;
                } else {
                    delete newErrors[`${index}-${name}`];
                }
            }
            else if (updatedRow.deduction_type === "withheldDeduction" && name === "withheld_release_amount") {
                const maxAllowed = Number(matched?.withheld_deduction_amount) || 0; // ✅ matched is accessible now
                const enteredValue = Number(value) || 0;

                if (enteredValue > maxAllowed) {
                    newErrors[`${index}-${name}`] = `Amount cannot exceed deduction limit of ${maxAllowed}`;
                } else {
                    delete newErrors[`${index}-${name}`];
                }
            }

            return newErrors;
        });
    };
    // const handlePreviousYearReleaseInputChange = (e, index) => {
    //     const { name, value } = e.target;
    //     setPreviousYearReleaseData((prevFormData) => {
    //         const newFields = [...prevFormData];
    //         newFields[index] = {
    //             ...newFields[index],
    //             [name]: value,
    //         };
    //         return newFields;
    //     });

    //     setErrors((prevErrors) => {
    //         const newErrors = { ...prevErrors };
    //         if (value.trim() !== "") {
    //             delete newErrors[`${index}-${name}`];
    //         }
    //         return newErrors;
    //     });
    // };
    const handleDeductionInputChange = (e, index) => {
        const { name, value } = e.target;
        setDeductionData((prevFormData) => {
            const newFields = [...prevFormData];
            newFields[index] = {
                ...newFields[index],
                [name]: value,
            };
            return newFields;
        });

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value.trim() !== "") {
                delete newErrors[`${index}-${name}`];
            }
            return newErrors;
        });
    };


    const handleWithheldReleaseInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedRow = {
            ...WithheldRelease[index],
            [name]: value,
        };

        const matched = deductionInvoices.find(
            (item) => item.id === (name === "deduction_id" ? value : updatedRow.deduction_id)
        );

        if (name === "deduction_id") {
            updatedRow.withheld_release_amount = Number(matched?.withheld_deduction_amount) || Number(matched?.deduction_amount) || 0;
        }

        setWithheldRelease((prevFormData) => {
            const newFields = [...prevFormData];
            newFields[index] = updatedRow;
            return newFields;
        });

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };

            if (value.trim() !== "") {
                delete newErrors[`${index}-${name}`];
            }


            else if (name === "withheld_release_amount") {
                const maxAllowed = Number(matched?.withheld_deduction_amount) || 0; // ✅ matched is accessible now
                const enteredValue = Number(value) || 0;

                if (enteredValue > maxAllowed) {
                    newErrors[`${index}-${name}`] = `Amount cannot exceed deduction limit of ${maxAllowed}`;
                } else {
                    delete newErrors[`${index}-${name}`];
                }
            }

            return newErrors;
        });
    };
    const handleWithhelddeductionInputChange = (e, index) => {
        const { name, value } = e.target;
        setWithheldDeductionData((prevFormData) => {
            const newFields = [...prevFormData];
            newFields[index] = {
                ...newFields[index],
                [name]: value,
            };
            return newFields;
        });

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value.trim() !== "") {
                delete newErrors[`${index}-${name}`];
            }
            return newErrors;
        });
    };

    const initialFormData = {
        remunerationfor_keyproffesional: "",
        remunerationfor_subproffesional: "",
        office_rent: "",
        road_survey: "",
        reports: "",
        contingencies: "",
        duty_travel: "",
        transport: "",
        support_staff: "",
        office_supplies: "",
        office_furniture: "",
        local_professional_staff: "",
        sub_total_A: "",
        escalation_5_percentage_ofsubtotal: "",
        net_ammount: "",
        gst_18_percentage: "",
        gross_bill_ammount_B: "",
        tds_it_percentage: "",
        tds_it_amount: "",
        tds_gst_percentage: 0,
        amotds_gst_amountunt: "",
        withheld_gst_amount: "0",
        net_payable_amount: "",
        tds_deducted_10_percentage: "10",
        gst_tds_2_percentage: "2",
        other_deduction: "",
        total_deduction: "",
        company_name: "",
        date: "",
        consultant_invoice: invoice_id,
        account_number: "",
        ifsc_code: "",
        bank_name: "",
        total_bill_without_escalation: "",
        escalation_percentage: "",
        escalation_amount: "",
        total_bill_amount: "0",
        gst_amount: "",
        road_survey_reduction_reason: null,
        reports_reduction_reason: null,
        office_furniture_reduction_reason: null,
        office_supplies_reduction_reason: null,
        office_rent_reduction_reason: null,
        duty_travel_reduction_reason: null,
        transport_reduction_reason: null,
        employee_deduction_reason: null,
    };



    const handleClose = (event) => {
        if (event) {
            event.preventDefault();
        }
        setShow(false);
        setErrors({})
        setFormData(initialFormData);
        setPReviousMonthreleaseData([]);
        setPreviousYearReleaseData([]);
        // setProject(initialProject);

    }





    const getProjects = async () => {
        // setBuffering(true); //buffering logic // Start Buffering
        try {
            // const pro = await axios.get(`${BASE_URL}/siteproject/project/`);
            const pro = await axios.get(
                sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
                    `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                    : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
                        `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
                        : `${BASE_URL}/siteproject/project/`
            );
            const sortedProjects = sortProjects(pro.data, 'site_prcode');
            setProjectList(sortedProjects);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            // setBuffering(false);// End Buffering
        }
    };
    const getInvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id ? p_id : project_id}/null/null/`
            );

            // Ensure the filter condition returns a value
            const filterInvoice = res.data.filter(invoice => invoice.month < month);

            // Set the filtered invoices
            setInvoiceList(filterInvoice);
        } catch (err) {
            console.error("Error fetching invoices:", err);
        }
    };




    useEffect(() => {
        getInvoice();
    }, [p_id]);


    const [formData, setFormData] = useState({
        remunerationfor_keyproffesional: "",
        remunerationfor_subproffesional: "",
        office_rent: "",
        office_supplies: "",
        office_furniture: "",
        road_survey: "",
        reports: "",
        contingencies: "",
        duty_travel: "",
        transport: "",
        support_staff: "",
        sub_total_A: "",
        escalation_5_percentage_ofsubtotal: "",
        net_ammount: "",
        gst_18_percentage: "18",
        gross_bill_ammount_B: "",
        tds_it_percentage: "",
        local_professional_staff: "",
        tds_it_amount: "",
        tds_gst_percentage: 0,
        tds_gst_amount: "",
        withheld_gst_amount: "0",
        net_payable_amount: "",
        tds_deducted_10_percentage: "10",
        gst_tds_2_percentage: "2",
        other_deduction: "",
        total_deduction: "",
        company_name: "",
        date: "",
        consultant_invoice: invoice_id,
        account_number: "",
        ifsc_code: "",
        address: "",
        bank_name: "",
        total_bill_without_escalation: "",
        escalation_percentage: "",
        escalation_amount: "",
        total_bill_amount: "0",
        gst_amount: "",
        road_survey_reduction_reason: null,
        reports_reduction_reason: null,
        office_furniture_reduction_reason: null,
        office_supplies_reduction_reason: null,
        office_rent_reduction_reason: null,
        duty_travel_reduction_reason: null,
        transport_reduction_reason: null,
        employee_deduction_reason: null,

    });


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "account_number",
            "address",
            "bank_name",
            "company_name",
            "date",
            "escalation_percentage",
            "ifsc_code",
            "tds_it_percentage",

        ].filter(Boolean)

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        console.log("newErrors")
        console.log(newErrors)
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;;
    }





    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (errors[name]) {
            setErrors((prevErrors) => {
                const { [name]: removedError, ...restErrors } = prevErrors;
                return restErrors;
            });
        }

    };

    useEffect(() => {
        const totalAmt = previousMonthReleaseData.reduce(
            (acc, curr) => acc + (parseFloat(curr.deduction_amount) || 0),
            0
        );
        const totalAmt2 = previousMonthReleaseData.reduce(
            (acc, curr) => acc + (parseFloat(curr.withheld_release_amount) || 0),
            0
        );
        const totalPreviousYearAmt = PreviousYearReleaseData.reduce(
            (acc, curr) => acc + (parseFloat(curr.deduction_amount) || 0),
            0
        );
        const totalPreviousYearAmt2 = PreviousYearReleaseData.reduce(
            (acc, curr) => acc + (parseFloat(curr.withheld_release_amount) || 0),
            0
        );
        const totalDeductionAmt = deductionData.reduce(
            (acc, curr) =>
                acc +
                (parseFloat(curr.deduction_amount) || 0) +
                (parseFloat(curr.withheld_deduction_amount) || 0),
            0
        );
        const totalwithheldreleaseAmt = WithheldRelease.reduce(
            (acc, curr) => acc + (parseFloat(curr.withheld_release_amount) || 0),
            0
        );
        const totalwithheldDeductionAmt = WithheldDeductionData.reduce(
            (acc, curr) => acc + (parseFloat(curr.withheld_deduction_amt) || 0),
            0
        );
        setTotalPreviousMonthAmt(totalAmt + totalAmt2);
        setTotalPreviousYearAmt(totalPreviousYearAmt + totalPreviousYearAmt2);
        setTotalDeductionAmt(totalDeductionAmt);
        setwithheldReleaseAmt(totalwithheldreleaseAmt);
        settotalWithhelDeductionAmt(totalwithheldDeductionAmt);
    }, [previousMonthReleaseData, PreviousYearReleaseData, deductionData, WithheldRelease, WithheldDeductionData]);

    //     const local_professional_staff =
    //         (Number(formData.remunerationfor_keyproffesional) || 0) +
    //         (Number(formData.remunerationfor_subproffesional) || 0) +
    //         (Number(formData.support_staff) || 0);
    //     let total =
    //         (Number(formData.remunerationfor_keyproffesional) || 0) +
    //         (Number(formData.remunerationfor_subproffesional) || 0) +
    //         (Number(formData.office_rent) || 0) +
    //         (Number(formData.support_staff) || 0) +
    //         (Number(formData.office_supplies) || 0) +
    //         (Number(formData.reports) || 0) +
    //         (Number(formData.contingencies) || 0) +
    //         (Number(formData.duty_travel) || 0) +
    //         (Number(formData.road_survey) || 0) +
    //         (Number(formData.transport) || 0) +
    //         (Number(formData.office_furniture) || 0);
    //     total += totalPreviousMonthAmt;


    //     console.log("Updated Total (with Previous Month Amount):", total);
    //     const subTotal_A = total;




    //     const Esclation_Amount = (Number(formData.escalation_percentage) / 100 || 0) * subTotal_A;
    //     const Net_Amount = subTotal_A + Esclation_Amount;
    //     const GST_Amount = (Number(formData.gst_18_percentage) / 100 || 0) * Net_Amount;
    //     const Gross_B = GST_Amount + Net_Amount;
    //     const TDS_Amount = (Number(formData.tds_it_percentage) / 100 || 0) * Net_Amount;
    //     const TDS_GST_Amount = (Number(formData.gst_tds_2_percentage) / 100 || 0) * TDS_Amount;
    //     const Total_Deduction = TDS_Amount + TDS_GST_Amount + GST_Amount
    //     const Net_Payable_Amount = Gross_B - Total_Deduction
    //     setFormData(prevFormData => ({
    //         ...prevFormData,
    //         local_professional_staff: local_professional_staff.toFixed(0),
    //         total_bill_without_escalation: subTotal_A.toFixed(0),
    //         escalation_amount: Esclation_Amount.toFixed(0),
    //         net_ammount: Net_Amount.toFixed(0),
    //         gst_amount: GST_Amount.toFixed(0),
    //         withheld_gst_amount: GST_Amount.toFixed(0),
    //         gross_bill_ammount_B: Gross_B.toFixed(0),
    //         tds_it_amount: TDS_Amount.toFixed(0),
    //         tds_gst_amount: TDS_GST_Amount.toFixed(0),
    //         total_deduction: Total_Deduction.toFixed(0),
    //         net_payable_amount: Net_Payable_Amount.toFixed(0)

    //     }));





    // };


    useEffect(() => {
        if (calculateTotalEmployeeDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                remunerationfor_keyproffesional: calculateTotalEmployeeDeductions
            }))
        }
        else if (calculateTotalEmployeeDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                remunerationfor_keyproffesional: calculateTotalEmployee
            }))
        }
    }, [calculateTotalEmployeeDeductions, calculateTotalEmployee])


    useEffect(() => {
        if (calculateCurrentAmountSubDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                remunerationfor_subproffesional: calculateCurrentAmountSubDeductions
            }))
        }
        else if (calculateCurrentAmountSubDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                remunerationfor_subproffesional: calculateCurrentAmountSub
            }))
        }
    }, [calculateCurrentAmountSubDeductions, calculateCurrentAmountSub])


    useEffect(() => {
        if (calculateCurrentAmountSupportDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                support_staff: calculateCurrentAmountSupportDeductions
            }))
        }
        else if (calculateCurrentAmountSupportDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                support_staff: calculateCurrentAmountSupport
            }))
        }
    }, [calculateCurrentAmountSupportDeductions, calculateCurrentAmountSupport])
    useEffect(() => {
        if (calculateTotaltransportDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                transport: calculateTotaltransportDeductions
            }))
        }
        else if (calculateTotaltransportDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                transport: calculateTotaltransport
            }))
        }
    }, [calculateTotaltransportDeductions, calculateTotaltransport])

    useEffect(() => {
        if (calculateTotalDutyDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                duty_travel: calculateTotalDutyDeductions
            }))
        }
        else if (calculateTotalDutyDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                duty_travel: calculateTotalDuty
            }))
        }
    }, [calculateTotalDutyDeductions, calculateTotalDuty])
    useEffect(() => {
        if (calculateTotalRentDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                office_rent: calculateTotalRentDeductions
            }))
        }
        else if (calculateTotalRentDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                office_rent: calculateTotalRent
            }))
        }
    }, [calculateTotalRentDeductions, calculateTotalRent])
    useEffect(() => {
        if (calculateTotalSuppliesDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                office_supplies: calculateTotalSuppliesDeductions
            }))
        }
        else if (calculateTotalSuppliesDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                office_supplies: calculateTotalSupplies
            }))
        }
    }, [calculateTotalSuppliesDeductions, calculateTotalSupplies])

    useEffect(() => {
        if (calculateTotalReportsDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                reports: calculateTotalReportsDeductions
            }))
        }
        else if (calculateTotalReportsDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                reports: calculateTotalReports
            }))
        }
    }, [calculateTotalReportsDeductions, calculateTotalReports])

    useEffect(() => {
        if (calculatetotalFurnitureDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                office_furniture: calculatetotalFurnitureDeductions
            }))
        }
        else if (calculatetotalFurnitureDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                office_furniture: calculatetotalFurniture
            }))
        }
    }, [calculatetotalFurnitureDeductions, calculatetotalFurniture])
    useEffect(() => {
        if (calculateTotalSurevyDeductions > 0) {
            setFormData((prev) => ({
                ...prev,
                road_survey: calculateTotalSurevyDeductions
            }))
        }
        else if (calculateTotalSurevyDeductions === 0) {
            setFormData((prev) => ({
                ...prev,
                road_survey: calculateTotalSurevy
            }))
        }
    }, [calculateTotalSurevyDeductions, calculateTotalSurevy])



    const calculateTotalBillWithoutEscalation = () => {
        const local_professional_staff =
            (Number(formData.remunerationfor_keyproffesional) || 0) +
            (Number(formData.remunerationfor_subproffesional) || 0) +
            (Number(formData.support_staff) || 0);

        let total =
            (Number(formData.remunerationfor_keyproffesional) || 0) +
            (Number(formData.remunerationfor_subproffesional) || 0) +
            (Number(formData.office_rent) || 0) +
            (Number(formData.support_staff) || 0) +
            (Number(formData.office_supplies) || 0) +
            (Number(formData.reports) || 0) +
            (Number(formData.contingencies) || 0) +
            (Number(formData.duty_travel) || 0) +
            (Number(formData.road_survey) || 0) +
            (Number(formData.transport) || 0) +
            (Number(formData.office_furniture) || 0);

        const total_bill_without_escalation = total + totalPreviousMonthAmt;



        console.log("Total Previous Month Amount:", totalPreviousMonthAmt);
        console.log("Total Bill Without Escalation:", total_bill_without_escalation);

        const subTotal_A = total_bill_without_escalation;
        const escalationAmount = (Number(formData.escalation_percentage) / 100 || 0) * subTotal_A;
        const netAmount = (subTotal_A + escalationAmount + totalPreviousYearAmt) - totalDeductionAmt;
        const gstAmount = (Number(formData.gst_18_percentage) / 100 || 0) * netAmount;
        const grossAmount = gstAmount + netAmount;
        const tdsAmount = (Number(formData.tds_it_percentage) / 100 || 0) * netAmount;
        const tdsGstAmount = (Number(formData.gst_tds_2_percentage) / 100 || 0) * netAmount;
        const totalDeduction = (tdsAmount + tdsGstAmount + totalWithhelDeductionAmt) + ((Number(formData.withheld_gst_amount) || 0));
        const netPayableAmount = (grossAmount - totalDeduction) + withheldReleaseAmt;

        setFormData(prevFormData => ({
            ...prevFormData,
            local_professional_staff: local_professional_staff.toFixed(0),
            total_bill_without_escalation: total_bill_without_escalation.toFixed(0),
            escalation_amount: escalationAmount.toFixed(0),
            net_ammount: netAmount.toFixed(0),
            gst_amount: gstAmount.toFixed(0),
            gross_bill_ammount_B: grossAmount.toFixed(0),
            tds_it_amount: tdsAmount.toFixed(0),
            tds_gst_amount: tdsGstAmount.toFixed(0),
            total_deduction: totalDeduction.toFixed(0),
            net_payable_amount: netPayableAmount.toFixed(0)
        }));
    };



    console.log("formData.total_bill_without_escalation")
    console.log(formData.total_bill_without_escalation)

    const handlePreviousMonthReleaseData = (e) => {
        e.preventDefault();
        setPReviousMonthreleaseData((prevFormData) => [
            ...prevFormData,
            {
                previous_invoice_id: "",
                deduction_id: "",
                deduction_type: "",
                date: null,
                deduction_amount: "",
                release_month: "",
                description: "",
                escalation_percentage: "",
                withheld_release_amount: "",
                month: month,
                year: year,
                invoice_id: invoice_id,
                project: p_id,

            },
        ]);
    };

    const handlePreviousYearReleaseData = (e) => {
        e.preventDefault();
        setPreviousYearReleaseData((prevFormData) => [
            ...prevFormData,
            {
                previous_invoice_id: "",
                deduction_id: "",
                deduction_type: "",
                date: null,
                deduction_amount: "",
                release_month: "",
                description: "",
                escalation_percentage: "0",
                withheld_release_amount: "",
                month: month,
                year: year,
                project: p_id,
                invoice_id: invoice_id,

            },
        ]);
    };

    const handlePreviousYearReleaseInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedRow = {
            ...PreviousYearReleaseData[index],
            [name]: value,
        };

        const matched = deductionInvoices.find(
            (item) => item.id === (name === "deduction_id" ? value : updatedRow.deduction_id)
        );

        // ✅ Recalculate when EITHER deduction_id OR escalation_percentage changes
        if (
            updatedRow.deduction_type === "deduction" &&
            (name === "deduction_id" || name === "escalation_percentage")
        ) {
            const baseAmount = Number(matched?.deduction_amount) || 0;
            const escalation = Number(updatedRow.escalation_percentage) || 0; // ✅ use updatedRow so new % is picked up
            const escalationAmount = (baseAmount * escalation) / 100;
            updatedRow.deduction_amount = (baseAmount + escalationAmount).toFixed(0);
            const release_month = Number(matched?.deduction_month).toFixed(2) || 0;
            updatedRow.release_month = (release_month);

        }
        else if (
            updatedRow.deduction_type === "withheldDeduction" &&
            (name === "deduction_id" || name === "escalation_percentage")
        ) {
            const baseAmount = Number(matched?.withheld_deduction_amount) || 0;
            const escalation = Number(updatedRow.escalation_percentage) || 0; // ✅ use updatedRow so new % is picked up
            const escalationAmount = (baseAmount * escalation) / 100;
            updatedRow.withheld_release_amount = (baseAmount + escalationAmount).toFixed(0);
        }

        setPreviousYearReleaseData((prevFormData) => {
            const newFields = [...prevFormData];
            newFields[index] = updatedRow;
            return newFields;
        });

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };

            if (value.trim() !== "") {
                delete newErrors[`${index}-${name}`];
            }

            if (updatedRow.deduction_type === "deduction" && name === "deduction_amount") {
                const maxAllowed = Number(matched?.deduction_amount) || 0;
                const enteredValue = Number(value) || 0;

                if (enteredValue > maxAllowed) {
                    newErrors[`${index}-${name}`] = `Amount cannot exceed deduction limit of ${maxAllowed}`;
                } else {
                    delete newErrors[`${index}-${name}`];
                }
            } else if (updatedRow.deduction_type === "withheldDeduction" && name === "withheld_release_amount") {
                const maxAllowed = Number(matched?.withheld_deduction_amount) || 0;
                const enteredValue = Number(value) || 0;

                if (enteredValue > maxAllowed) {
                    newErrors[`${index}-${name}`] = `Amount cannot exceed deduction limit of ${maxAllowed}`;
                } else {
                    delete newErrors[`${index}-${name}`];
                }
            }

            return newErrors;
        });
    };
    const handleDeductionData = (e) => {
        e.preventDefault();
        setDeductionData((prevFormData) => [
            ...prevFormData,
            {
                deduction_reason: "",
                deduction_amount: "",
                withheld_deduction_reason: "",
                withheld_deduction_amount: "",
                invoice_id: invoice_id,
                invoice_type: "null",
                project: p_id,
            },
        ]);
    };
    const handleWithheldReleaseAdd = (e) => {
        e.preventDefault();
        setWithheldRelease((prevFormData) => [
            ...prevFormData,
            {
                previous_invoice_id: "",
                deduction_id: "",
                deduction_type: "",
                date: null,
                deduction_amount: "",
                release_month: "",
                description: "",
                withheld_release_amount: "",
                month: month,
                year: year,
                project: p_id,
                invoice_id: invoice_id,
            },
        ]);
    };
    const handleWithheldDeductionAdd = (e) => {
        e.preventDefault();
        setWithheldDeductionData((prevFormData) => [
            ...prevFormData,
            {
                deduction_reason: "",
                deduction_amount: "",
                withheld_deduction_reason: "",
                withheld_deduction_amount: "",
                invoice_id: invoice_id,
                invoice_type: "null",
                project: p_id,
            },
        ]);
    };
    const handleRemovePreviousMonth = (index) => {
        setPReviousMonthreleaseData((prevFormData) => {
            const updatedData = prevFormData.filter((_, i) => i !== index);
            return [...updatedData]; // Ensures React re-renders correctly
        });

        // Update fileInputRefs properly
        fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
    };
    const handleRemoveDocument = (index) => {
        setPreviousYearReleaseData((prevFormData) => {
            const updatedData = prevFormData.filter((_, i) => i !== index);
            return [...updatedData]; // Ensures React re-renders correctly
        });

        // Update fileInputRefs properly
        fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
    };
    const handleRemoveDeductionfield = (index) => {
        setDeductionData((prevFormData) => {
            const updatedData = prevFormData.filter((_, i) => i !== index);
            return [...updatedData]; // Ensures React re-renders correctly
        });

        // Update fileInputRefs properly
        fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
    };
    const handleWithheldRemoveField = (index) => {
        setWithheldRelease((prevFormData) => {
            const updatedData = prevFormData.filter((_, i) => i !== index);
            return [...updatedData]; // Ensures React re-renders correctly
        });

        // Update fileInputRefs properly
        fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
    };
    const handleRemoveWithheldDeduction = (index) => {
        setWithheldDeductionData((prevFormData) => {
            const updatedData = prevFormData.filter((_, i) => i !== index);
            return [...updatedData]; // Ensures React re-renders correctly
        });

        // Update fileInputRefs properly
        fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
    };


    // Use useEffect to call calculateTotalBillWithoutEscalation whenever dependencies change
    // useEffect(() => {
    //     calculateTotalBillWithoutEscalation();
    // }, [
    //     formData.remunerationfor_keyproffesional, formData.remunerationfor_subproffesional, formData.office_rent, formData.support_staff, formData.office_supplies, formData.transport, formData.reports, formData.contingencies, formData.duty_travel, formData.road_survey, formData.office_furniture, formData.escalation_percentage,
    //     formData.gst_18_percentage, formData.tds_it_percentage, formData.gst_tds_2_percentage, formData.local_professional_staff,
    // ]);


    useEffect(() => {
        calculateTotalBillWithoutEscalation();
    }, [
        formData.remunerationfor_keyproffesional,
        formData.remunerationfor_subproffesional,
        formData.office_rent,
        formData.support_staff,
        formData.office_supplies,
        formData.transport,
        formData.reports,
        formData.contingencies,
        formData.duty_travel,
        formData.road_survey,
        formData.office_furniture,
        formData.escalation_percentage,
        formData.gst_18_percentage,
        formData.tds_it_percentage,
        formData.gst_tds_2_percentage,
        formData.local_professional_staff,
        totalPreviousMonthAmt,
        totalPreviousYearAmt,
        totalDeductionAmt,
        withheldReleaseAmt,
        totalWithhelDeductionAmt,
        formData.withheld_gst_amount
    ]);




    const [loading, setLoading] = useState(false); //loading logic

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setShowProgressModal(true);
            setLoading(true);
            setUploadProgress(0);
            const loadingToastId = toast.loading("Adding: Please wait..."); // Toast logic
            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100); // Smooth animation
            try {
                let ress = await axios.post(
                    `${BASE_URL}/siteproject/paymentrecieved/`,
                    formData
                );

                if (ress.status === 200) {
                    const generatedId = ress.data.id;

                    const isDataFilled = [...previousMonthReleaseData, ...PreviousYearReleaseData, ...WithheldRelease, ...WithheldDeductionData].some(data =>
                        Object.values(data).some(value => value !== "" && value !== "null")
                    );
                    const isDeductionDataFilled = [...deductionData].some(data =>
                        Object.values(data).some(value => value !== "" && value !== "null")
                    );

                    if (isDataFilled) {
                        const updatedPreviousMonthData = previousMonthReleaseData.map((data) => ({
                            ...data,
                        }));

                        const updatedPreviousyearData = PreviousYearReleaseData.map((data) => ({
                            ...data,
                        }));
                        const updateDeductionData = deductionData.map((data) => ({
                            ...data,
                        }));
                        const updatedWithheldReleaseData = WithheldRelease.map((data) => ({
                            ...data,
                        }));
                        const updatedWithheldDeductionData = WithheldDeductionData.map((data) => ({
                            ...data,
                        }));

                        const mergedData = [...updatedPreviousMonthData, ...updatedPreviousyearData, ...updatedWithheldReleaseData, ...updatedWithheldDeductionData];
                        await axios.post(
                            `${BASE_URL}/siteproject/bulkinvoicedeductionrelease/`,
                            mergedData
                        );
                        setPReviousMonthreleaseData(updatedPreviousMonthData);
                        setPreviousYearReleaseData(updatedPreviousyearData);
                        setDeductionData(updateDeductionData);
                        setWithheldRelease(updatedWithheldReleaseData);
                        setWithheldDeductionData(updatedWithheldDeductionData);

                    }
                    if (isDeductionDataFilled) {
                        const updateDeductionData = deductionData.map((data) => ({
                            ...data,
                        }));
                        await axios.post(
                            `${BASE_URL}/siteproject/bulkinvoicededuction/`,
                            updateDeductionData
                        );
                        setDeductionData(updateDeductionData);
                    }
                    handleClose();
                    await getPayment();
                    setTimeout(() => {
                        toast.dismiss(loadingToastId);
                        toast.success("PaymentReceipt Added Successfully");;
                    }, 1000);
                }
                else {
                    alert(ress);
                }
            } catch (err) {
                clearInterval(interval); // ❌ Stop progress
                setUploadProgress(0);    // 🧹 Reset if needed
                handleErrorToast(err);   // ⚠️ Show error
            } finally {
                clearInterval(interval); // Ensure cleanup

                setTimeout(() => {
                    setShowProgressModal(false); // ✅ Hide modal
                }, 1500);

                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    console.log("Withheld Release Fields", WithheldRelease)

    const [AccountDetailsList, setAccountDetailsList] = useState([]);

    const getAccountDetails = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/consultantaccountdetails/`);
            setAccountDetailsList(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };



    const [companyList, setCompanyList] = useState([]);



    const getSubcompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setCompanyList(res.data);

        } catch (error) {
            handleErrorToast(error)
        }
    };

    const [filterAccountDetails, setFilterAccountDetails] = useState([]);


    useEffect(() => {
        if (show === true) {
            getAccountDetails();
            getSubcompany();
        }
    }, [show]);




    useEffect(() => {
        if (AccountDetailsList.length > 0 && companyList.length > 0) {

            const filtered = companyList.filter((company) =>
                AccountDetailsList.some((acc) => acc.company_name === company.id)
            );

            setFilterAccountDetails(filtered);
        }
    }, [AccountDetailsList, companyList]);

    const [selectedAccount, setselectedAccount] = useState("null");

    const accountOptions = filterAccountDetails.map((i) => ({
        label: i.title,
        value: i.id,
    }));

    const handleAccountChange = (selectedOption) => {
        if (!selectedOption) {
            setselectedAccount("null");
        }
        setselectedAccount(selectedOption.value);
    };

    useEffect(() => {
        if (selectedAccount !== "null") {
            const filterAccoutData = AccountDetailsList.find(
                (i) => i.company_name === selectedAccount

            );
            const filterCompanyname = companyList.find(
                (i) => i.id === selectedAccount
            );
            setFormData((prevFormData) => ({
                ...prevFormData,
                company_name: filterCompanyname?.title,
                ifsc_code: filterAccoutData?.ifsc_code,
                account_number: filterAccoutData?.account_number,
                bank_name: filterAccoutData?.bank_name,
                address: filterAccoutData?.address,


            }))
        }
    }, [selectedAccount, AccountDetailsList])

    const [deductionInvoices, setDeductionInvoices] = useState([]);


    const getDeductionInvoices = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/${p_id}/null/null/`);
            setDeductionInvoices(res.data);
        } catch (error) {
            handleErrorToast(error);
        }
    };

    useEffect(() => {
        if (p_id) {
            getDeductionInvoices();
        }
    }, [p_id]);




    const deductionInvoiceIds = deductionInvoices.map((invoice) => invoice.invoice_id);
    const deductionDatapreviousInvoice = deductionInvoices.filter((invoice) => {
        if (invoice.year < year) return true;
        if (invoice.year === year && invoice.month < month) return true;
        return false;
    });
    console.log("deductionInvoiceIdsSSSSS", deductionDatapreviousInvoice);


    const uniqueInvoiceIds = new Set(
        deductionInvoices.map(item => item.invoice_id)
    );
    const paymentDeductionData = deductionInvoices.filter(item => item.item_id === null)

    const uniqueInvoiceIdsPayment = new Set(
        paymentDeductionData.map(item => item.invoice_id)
    );

    const filteredData = invoiceList.filter(item =>
        uniqueInvoiceIds.has(item.id)
    );
    const filteredDataPayment = invoiceList.filter(item =>
        uniqueInvoiceIdsPayment.has(item.id)
    );


    console.log("filteredData", filteredData);
    const itemids = filteredData.map(item => item.item_id);

    console.log("itemids", itemids);






    const [withheldReleaseFormdata, setWithheldReleaseFormdata] = useState([{
        withheld_release_amount: "",
        release_month: "",
        deduction_amount: "",
        date: null,
        deduction_type: "",
        deduction_id: "",
    }]);


    const handleReleaseInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedData = [...withheldReleaseFormdata];

        updatedData[index][name] = value;
        setWithheldReleaseFormdata(updatedData);
    };


    const matchedDeductions = deductionInvoices?.filter((item) =>
        previousMonthReleaseData?.some(
            (row) =>
                row?.previous_invoice_id &&
                item?.invoice_id &&
                row.previous_invoice_id === item.invoice_id
        )
    );


    console.log("matchedDeductions", matchedDeductions);
    console.log("previousMonthReleaseData", previousMonthReleaseData);

    const matchedDeduction = deductionInvoices?.filter((item) => item.invoice_type === "Deduction")
    const matchedDeductionPayment = deductionInvoices?.filter((item) => item.invoice_type === "deduction")
    const matchedBothDeduction = deductionInvoices?.filter((item) => item.invoice_type === "Both")
    const matchedWithheldDeduction = deductionInvoices?.filter((item) => item.invoice_type === "WithHeldDeduction")
    const matchedPaymentWithheldDeduction = deductionInvoices?.filter((item) => item.invoice_type === "withheldDeduction")



    const deductionAndBoth = [
        ...(matchedDeduction || []),
        ...(matchedBothDeduction || [])
    ];
    const withheldAndBoth = [
        ...(matchedWithheldDeduction || []),
        ...(matchedBothDeduction || [])
    ];
    const bothDeductions = [
        ...(matchedDeductionPayment || []),
        ...(matchedPaymentWithheldDeduction || [])
    ];

    const filterWithheldRelease = deductionInvoices.filter((deduction) =>
        Array.isArray(releaseByProject) && releaseByProject.some((i) => i.deduction_id === deduction.id)
    );


    console.log(filterWithheldRelease, "filterWithheldRelease")
    console.log(releaseByProject, "releaseByProject")


    const getEscalationPercent = (project, checkDate = new Date()) => {
        const baseDateStr =
            project.escalation_apllicable_on === "Bid Due Date"
                ? project.bid_due_date
                : project.escalation_apllicable_on === "Contract Agreement Date" ? project.agreement_date :
                    project.bid_due_date
            ;

        if (!baseDateStr) return 0;

        const baseDate = new Date(baseDateStr);
        const today = new Date(checkDate);

        let years = today.getFullYear() - baseDate.getFullYear();

        const anniversaryThisYear = new Date(baseDate);
        anniversaryThisYear.setFullYear(baseDate.getFullYear() + years);

        if (today < anniversaryThisYear) {
            years -= 1;
        }

        if (years < 1) return 0;

        return years * 5; // escalation percentage
    };

    const escalationPercent = getEscalationPercent(projectbyid);

    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            escalation_percentage: escalationPercent,
            gst_18_percentage: 18
        }));
    }
        , [escalationPercent, show]);



    return (
        <>

            <button
                className="model-delete-button-modern actionn-icon form-field flex-row" style={{ backgroundColor: "#00000075", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                onClick={handleShow}
                title="Payment Receipt"
            >
                <PlusCircleIcon size={18} color="#fff" /><label style={{ color: "white" }}>Payment Receipt</label>

            </button>

            {
                showProgressModal ?
                    <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
                    show === true ?
                        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width95vw" size="xl">
                            <Modal.Header className="modern-modal-header">
                                <div className="header-content">
                                    <div style={{ color: "white" }}>
                                        <AddwithWhiteCircle />
                                    </div>
                                    <div>
                                        <Modal.Title>Add Payment Receipt Details</Modal.Title>
                                        <p className="header-subtitle" style={{ color: "white" }}>
                                            Fill account, deduction & release details to generate the receipt
                                        </p>
                                    </div>
                                </div>
                                <button className="close-btn" onClick={handleClose}>
                                    <X size={20} />
                                </button>
                            </Modal.Header>
                            <Modal.Body className="modern-modal-body">
                                <ToastContainer position="top-center" autoClose={3000} hideProgressBar />


                                <div className="form-section">
                                    <div className="section-title">   <Tag size={18} /><h4>Account Details</h4></div>

                                    <div className="form-grid4column">

                                        <div className="form-field">
                                            <label><Banknote size={14} /> Select Account Details<span className="required">*</span></label>
                                            <Select
                                                isClearable
                                                isSearchable
                                                options={accountOptions}
                                                onChange={handleAccountChange}
                                                value={accountOptions.find(
                                                    opt => opt.value === selectedAccount
                                                )}

                                                styles={CSSForSelectModern}
                                            />
                                            {errors.company_name && <div className="error-message font-size-text">{errors.company_name}</div>}
                                        </div>
                                        <div className="form-grid4column">
                                            <div className="form-field">
                                                <label ><Calendar size={14} />Date <span className="required">*</span></label>
                                                <input
                                                    type="date"
                                                    name="date"
                                                    placeholder="Date"
                                                    // min={0}
                                                    value={formData.date}
                                                    onChange={handleInputChange}
                                                />
                                                {errors.date && <div className="error-message font-size-text">{errors.date}</div>}
                                            </div>
                                            <div className="form-field">
                                                <label > <BookAlert size={16} /> Account Number<span className="required">*</span></label>
                                                <input
                                                    type="number"
                                                    name="account_number"
                                                    placeholder="Account Number"
                                                    min={0}
                                                    value={formData.account_number}
                                                    onChange={handleInputChange}
                                                    className={` width-10vw ${errors.account_number ? 'is-invalid' : ''}`}
                                                />
                                                {errors.account_number && <div className="error-message font-size-text">{errors.account_number}</div>}
                                            </div>
                                            <div className="form-field">
                                                <label ><TagIcon size={16} /> IFSC Code<span className="required">*</span></label>
                                                <input
                                                    type="text"
                                                    name="ifsc_code"
                                                    placeholder="IFSC Code"
                                                    min={0}
                                                    value={formData.ifsc_code}
                                                    onChange={handleInputChange}
                                                    className={`width-10vw ${errors.ifsc_code ? 'is-invalid' : ''}`}
                                                />
                                                {errors.ifsc_code && <div className="error-message font-size-text">{errors.ifsc_code}</div>}
                                            </div>
                                            <div className="form-field">
                                                <label ><Building size={16} /> Bank Name<span className="required">*</span></label>
                                                <input
                                                    type="text"
                                                    name="bank_name"
                                                    placeholder="Bank Name"
                                                    min={0}
                                                    value={formData.bank_name}
                                                    onChange={handleInputChange}
                                                    style={{ width: "26vw" }}
                                                    className={` ${errors.bank_name ? 'is-invalid' : ''}`}
                                                />
                                                {errors.bank_name && <div className="error-message font-size-text">{errors.bank_name}</div>}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="form-field" style={{ width: "100%" }}>
                                        <label><LucideIdCard size={16} /> Address<span className="required">*</span></label>
                                        <textarea
                                            type="text"
                                            name="address"
                                            placeholder="Address"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                            style={{ width: "98%" }}
                                            className={`form-input-textarea ${errors.address ? 'is-invalid' : ''}`}
                                        />
                                        {errors.address && <div className="error-message font-size-text">{errors.address}</div>}
                                    </div>






                                    <div className="section-title"><h4><PercentCircle size={16} />Percentages</h4></div>
                                    <div className="form-grid4column">

                                        <div className="form-field">
                                            <label>GST Percentage</label>
                                            <input
                                                type="number"
                                                name="gst_18_percentage"
                                                placeholder="GST Percentage"
                                                min={0}
                                                value={formData.gst_18_percentage}
                                                onChange={handleInputChange}
                                                className={` width-15vw ${errors.gst_18_percentage ? 'is-invalid' : ''}`}
                                            // disabled
                                            />
                                            {errors.gst_18_percentage && <div className="error-message font-size-text">{errors.gst_18_percentage}</div>}

                                        </div>
                                        <div className="form-field">
                                            <label >GST (TDS) Percentage</label>
                                            <input
                                                type="text"
                                                name="gst_tds_2_percentage"
                                                placeholder="GST Percentage"
                                                min={0}
                                                value={formData.gst_tds_2_percentage}
                                                onChange={handleInputChange}
                                                className={` width-15vw ${errors.gst_tds_2_percentage ? 'is-invalid' : ''}`}
                                            // disabled
                                            />
                                            {errors.gst_tds_2_percentage && <div className="error-message font-size-text">{errors.gst_tds_2_percentage}</div>}

                                        </div><div className="form-field">
                                            <label >TDS Percentage<span className="required">*</span></label>
                                            <input
                                                type="text"
                                                name="tds_it_percentage"
                                                placeholder="TDS Percentage"
                                                min={0}
                                                value={formData.tds_it_percentage}
                                                onChange={handleInputChange}
                                                className={` width-15vw ${errors.tds_it_percentage ? 'is-invalid' : ''}`}
                                            // disabled
                                            />
                                            {errors.tds_it_percentage && <div className="error-message font-size-text">{errors.tds_it_percentage}</div>}

                                        </div>
                                        <div className="form-field">
                                            <label >Escalation Percentage<span className="required">*</span></label>
                                            <input
                                                type="text"
                                                name="escalation_percentage"
                                                placeholder="Escalation Percentage"
                                                min={0}
                                                value={formData.escalation_percentage}
                                                onChange={handleInputChange}
                                                className={` width-15vw ${errors.escalation_percentage ? 'is-invalid' : ''}`}
                                            // disabled

                                            />
                                            {errors.escalation_percentage && <div className="error-message font-size-text">{errors.escalation_percentage}</div>}

                                        </div>
                                    </div>


                                    <div className="section-title" style={{ margin: '10px 0px' }}><h4>Bill Particulars</h4></div>
                                    <div className="pr-table-wrap">
                                        <div className="pr-table-scroll">
                                            <table className="pr-table">
                                                <thead className="">
                                                    <tr>
                                                        <th rowSpan="">S.No</th>
                                                        <th colSpan="1" className='align-center '>Particulars</th>
                                                        <th colSpan="1" className='align-center '>Invoice Amount</th>
                                                        <th colSpan="1" className='align-center width-20vw'>Amount</th>


                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <React.Fragment>
                                                        <tr>
                                                            <td>1</td>
                                                            <td colSpan="1" className="text-center">Remuneration for Key Professional Staff</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalEmployee || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalEmployeeDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>2</td>
                                                            <td className="text-center">Remuneration for Sub Professional Staff</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateCurrentAmountSub || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateCurrentAmountSubDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>3</td>
                                                            <td className="text-center">Support Staff</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateCurrentAmountSupport || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateCurrentAmountSupportDeductions || 0)}
                                                            </td>


                                                        </tr>
                                                        <tr>
                                                            <td>4</td>
                                                            <td className="text-center">Transportation</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotaltransport || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotaltransportDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>5</td>
                                                            <td className="text-center">Duty Travel</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalDuty || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalDutyDeductions || 0)}
                                                            </td>

                                                        </tr>

                                                        <tr>
                                                            <td>6</td>
                                                            <td className="text-center">Office Rent</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalRent || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalRentDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>7</td>
                                                            <td className="text-center">Office Supplies, Utilities and Communications</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalSupplies || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalSuppliesDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>8</td>
                                                            <td className="text-center">Office Furniture and Equipments</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculatetotalFurniture || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculatetotalFurnitureDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>9</td>
                                                            <td className="text-center">Reports and Documents</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalReports || 0)}
                                                            </td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalReportsDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>10</td>
                                                            <td className="text-center">Road Survey Equipment</td>
                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalSurevy || 0)}
                                                            </td>

                                                            <td colSpan="1" className="text-center">
                                                                {formatCurrencyIndian(calculateTotalSurevyDeductions || 0)}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>11</td>
                                                            <td className="text-center">Contingencies</td>
                                                            <td colSpan="2" className="text-center form-field" style={{ display: "table-cell" }}>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    name="contingencies"
                                                                    placeholder="Enter Amount"
                                                                    value={formData.contingencies}
                                                                    style={{ float: "right" }}
                                                                    onChange={handleInputChange}
                                                                    className={`  width-15vw text-end ${errors.contingencies ? 'is-invalid' : ''}`}

                                                                />
                                                                {errors.contingencies && <div className="error-message font-size-text">{errors.contingencies}</div>}</td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" ">Add Release Fields Without Escalation</td>

                                                            <td colspan="2" className="">
                                                                <button
                                                                    title=" Release Fields Without Escalation"
                                                                    className="btn-animated"
                                                                    onClick={handlePreviousMonthReleaseData}
                                                                    style={{ float: "inline-end" }}

                                                                >
                                                                    <div className="btn-content">
                                                                        <PlusCircle size={16} />
                                                                        <span>Release Fields Without Escalation</span>
                                                                    </div>
                                                                    <div className="btn-ripple"></div>
                                                                </button>
                                                                {/* <button title="Add Document" className="upload-svg" style={{ float: "inline-end" }} onClick={handlePreviousMonthReleaseData}>

                                                                    <AddwithWhiteCircle /> Release Fields Without Escalation
                                                                </button> */}
                                                            </td>
                                                        </tr>
                                                        {previousMonthReleaseData.map((data, index) => (
                                                            <tr >

                                                                <td colspan="1">

                                                                    <Select
                                                                        id="previous_invoice_id"
                                                                        name="previous_invoice_id"
                                                                        isClearable
                                                                        isSearchable
                                                                        options={filteredData?.map((i) => ({
                                                                            value: i.id,
                                                                            label: `Invoice No.: ${i.invoice_number}`,
                                                                        }))}
                                                                        value={filteredData
                                                                            ?.map((i) => ({
                                                                                value: i.id,
                                                                                label: `Invoice No.: ${i.invoice_number}`,
                                                                            }))
                                                                            .find((opt) => opt.value === data.previous_invoice_id) || null}
                                                                        onChange={(selectedOption) =>
                                                                            handlePreviousmonthInputChange(
                                                                                {
                                                                                    target: {
                                                                                        name: "previous_invoice_id",
                                                                                        value: selectedOption ? selectedOption.value : "",
                                                                                    },
                                                                                },
                                                                                index
                                                                            )
                                                                        }
                                                                        placeholder="Select Previous Invoice"
                                                                        styles={CSSForSelectModern15VWWidth}
                                                                    />
                                                                </td>
                                                                <td colspan="1">
                                                                    <div className="flex-row justify-between" style={{ marginTop: "10px" }} >
                                                                        {

                                                                            <>

                                                                                {data.previous_invoice_id ?
                                                                                    <>
                                                                                        <div className="flex-row justify-center" style={{ marginBottom: "10px" }}>
                                                                                            <Select
                                                                                                id="deduction_type"
                                                                                                name="deduction_type"
                                                                                                isClearable
                                                                                                isSearchable
                                                                                                options={[
                                                                                                    { value: "deduction", label: "Deduction Only" },
                                                                                                    { value: "withheldDeduction", label: "Withheld Deduction Only" },
                                                                                                    // { value: "both", label: "For Both" },
                                                                                                ]}
                                                                                                value={[
                                                                                                    { value: "deduction", label: "Deduction Only" },
                                                                                                    { value: "withheldDeduction", label: "Withheld Deduction Only" },
                                                                                                ].find((opt) => opt.value === data.deduction_type) || null}
                                                                                                onChange={(selectedOption) =>
                                                                                                    handlePreviousmonthInputChange(
                                                                                                        {
                                                                                                            target: {
                                                                                                                name: "deduction_type",
                                                                                                                value: selectedOption ? selectedOption.value : "",
                                                                                                            },
                                                                                                        },
                                                                                                        index
                                                                                                    )
                                                                                                }
                                                                                                placeholder="Select Deduction Type"
                                                                                                styles={CSSForSelectModern10VWWidth}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="flex-row justify-center" style={{ marginBottom: "10px" }}>
                                                                                            <Select
                                                                                                id="deduction_id"
                                                                                                name="deduction_id"
                                                                                                isClearable
                                                                                                isSearchable
                                                                                                isDisabled={!data.previous_invoice_id}
                                                                                                options={
                                                                                                    data.previous_invoice_id
                                                                                                        ? (data.deduction_type === "deduction"
                                                                                                            ? deductionAndBoth
                                                                                                            : data.deduction_type === "withheldDeduction"
                                                                                                                ? withheldAndBoth
                                                                                                                : data.deduction_type === "both"
                                                                                                                    ? matchedBothDeduction
                                                                                                                    : []
                                                                                                        )
                                                                                                            ?.filter((i) => i.invoice_id === data.previous_invoice_id)
                                                                                                            .map((i) => ({
                                                                                                                value: i.id,
                                                                                                                label: `${i.deduction_reason}/${i.invoice_type}`,
                                                                                                            }))
                                                                                                        : []
                                                                                                }
                                                                                                value={
                                                                                                    (data.previous_invoice_id
                                                                                                        ? (data.deduction_type === "deduction"
                                                                                                            ? deductionAndBoth
                                                                                                            : data.deduction_type === "withheldDeduction"
                                                                                                                ? withheldAndBoth
                                                                                                                : data.deduction_type === "both"
                                                                                                                    ? matchedBothDeduction
                                                                                                                    : []
                                                                                                        )
                                                                                                            ?.filter((i) => i.invoice_id === data.previous_invoice_id)
                                                                                                            .map((i) => ({
                                                                                                                value: i.id,
                                                                                                                label: `${i.deduction_reason}/${i.invoice_type}`,
                                                                                                            }))
                                                                                                        : []
                                                                                                    )?.find((opt) => opt.value === data.deduction_id) || null
                                                                                                }
                                                                                                onChange={(selectedOption) =>
                                                                                                    handlePreviousmonthInputChange(
                                                                                                        {
                                                                                                            target: {
                                                                                                                name: "deduction_id",
                                                                                                                value: selectedOption ? selectedOption.value : "",
                                                                                                            },
                                                                                                        },
                                                                                                        index
                                                                                                    )
                                                                                                }
                                                                                                placeholder={data.previous_invoice_id ? "Select Deduction Data" : "Select Invoice First"}
                                                                                                styles={CSSForSelectModern15VWWidth}
                                                                                            />
                                                                                        </div>
                                                                                    </> : <>
                                                                                        <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                            <h6 className="text-center">Select Previous Invoice First</h6>
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </div>




                                                                </td>



                                                                <td colspan="2">
                                                                    <div className="flex-row justify-between" >
                                                                        <>
                                                                            {
                                                                                data.previous_invoice_id ?
                                                                                    <div className="form-field">


                                                                                        <input

                                                                                            type="text"
                                                                                            min={0}
                                                                                            name="description"
                                                                                            value={data.description}
                                                                                            onChange={(e) => handlePreviousmonthInputChange(e, index)}
                                                                                            placeholder="Enter Releasing Description"
                                                                                            className="width-20vw text-start"
                                                                                        />
                                                                                        {errors[`${index}-description`] && (
                                                                                            <span className="error-message font-size-text">
                                                                                                {errors[`${index}-description`]}
                                                                                            </span>
                                                                                        )}


                                                                                    </div> : ""

                                                                            }
                                                                        </>

                                                                        <div className="flex-row" style={{ width: !data.previous_invoice_id && "100%" }}>
                                                                            <>
                                                                                {
                                                                                    data.previous_invoice_id ?
                                                                                        <>
                                                                                            {data.deduction_type === "deduction" &&
                                                                                                <div className="form-field">
                                                                                                    <input

                                                                                                        type="number"
                                                                                                        min={0}
                                                                                                        name="deduction_amount"
                                                                                                        value={data.deduction_amount}
                                                                                                        onChange={(e) => handlePreviousmonthInputChange(e, index)}
                                                                                                        placeholder="Enter Amount"
                                                                                                        className=" width-10vw text-end"
                                                                                                    />
                                                                                                    {errors[`${index}-deduction_amount`] && (
                                                                                                        <span className="error-message font-size-text">
                                                                                                            {errors[`${index}-deduction_amount`]}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>

                                                                                            }
                                                                                            {data.deduction_type === "withheldDeduction" &&
                                                                                                <>
                                                                                                    <input

                                                                                                        type="number"
                                                                                                        min={0}
                                                                                                        name="withheld_release_amount"
                                                                                                        value={data.withheld_release_amount}
                                                                                                        onChange={(e) => handlePreviousmonthInputChange(e, index)}
                                                                                                        placeholder="Enter Amount"
                                                                                                        className="form-input width-10vw text-end"
                                                                                                    />
                                                                                                    {errors[`${index}-withheld_release_amount`] && (
                                                                                                        <span className="error-message font-size-text">
                                                                                                            {errors[`${index}-withheld_release_amount`]}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </>

                                                                                            }
                                                                                        </> :
                                                                                        <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                            <h6 className="text-center">Select Previous Invoice First</h6>
                                                                                        </div>
                                                                                }
                                                                            </>


                                                                            {index === previousMonthReleaseData.length - 1 && (
                                                                                <button
                                                                                    title="Remove Document"
                                                                                    onClick={() => handleRemovePreviousMonth(index)}
                                                                                    className="file-clear clear-button2"
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            )}

                                                                        </div>


                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr >

                                                            <td colspan="2" className=" ">Sub Total (A)<span className="required">(Read-Only)</span></td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="total_bill_without_escalation"
                                                                        placeholder="Enter Amount"
                                                                        value={formData.total_bill_without_escalation}
                                                                        style={{ float: "right" }}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={` width-30vw  text-end  ${errors.total_bill_without_escalation ? ' is-invalid' : ''}`}
                                                                    />
                                                                    {errors.total_bill_without_escalation && (
                                                                        <div className="error-message font-size-text">{errors.total_bill_without_escalation}</div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr >



                                                            <td colspan="2" className=" ">Add Esclation {formData.escalation_percentage}% of Subtotal<span className="required">(Read-Only)</span></td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>

                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="escalation_amount"
                                                                        placeholder="Enter Amount"
                                                                        value={formData.escalation_amount}
                                                                        style={{ float: "right" }}

                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={` width-30vw text-end ${errors.escalation_amount ? ' is-invalid' : ''}`}
                                                                    />
                                                                    {errors.escalation_amount && (
                                                                        <div className="error-message font-size-text">{errors.escalation_amount}</div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" ">Add Released Fields With Escalation</td>

                                                            <td colspan="2" className="">
                                                                <button
                                                                    title=" Release Fields With Escalation"
                                                                    className="btn-animated"
                                                                    onClick={handlePreviousYearReleaseData}
                                                                    style={{ float: "inline-end" }}

                                                                >
                                                                    <div className="btn-content">
                                                                        <PlusCircle size={16} />
                                                                        <span>Release Fields With Escalation</span>
                                                                    </div>
                                                                    <div className="btn-ripple"></div>
                                                                </button>

                                                            </td>
                                                        </tr>
                                                        {PreviousYearReleaseData.map((data, index) => (
                                                            <tr >

                                                                <td colspan="1">


                                                                    <Select
                                                                        id="previous_invoice_id"
                                                                        name="previous_invoice_id"
                                                                        isClearable
                                                                        isSearchable
                                                                        options={filteredData?.map((i) => ({
                                                                            value: i.id,
                                                                            label: `Invoice No.: ${i.invoice_number}`,
                                                                        }))}
                                                                        value={filteredData
                                                                            ?.map((i) => ({
                                                                                value: i.id,
                                                                                label: `Invoice No.: ${i.invoice_number}`,
                                                                            }))
                                                                            .find((opt) => opt.value === data.previous_invoice_id) || null}
                                                                        onChange={(selectedOption) =>
                                                                            handlePreviousYearReleaseInputChange(
                                                                                {
                                                                                    target: {
                                                                                        name: "previous_invoice_id",
                                                                                        value: selectedOption ? selectedOption.value : "",
                                                                                    },
                                                                                },
                                                                                index
                                                                            )
                                                                        }
                                                                        placeholder="Select Previous Invoice"
                                                                        styles={CSSForSelectModern15VWWidth}
                                                                    />
                                                                </td>
                                                                <td colspan="1">
                                                                    {

                                                                        <>

                                                                            {data.previous_invoice_id ?
                                                                                <div className="flex-row justify-between" style={{ marginTop: "10px" }}>

                                                                                    <div className="flex-row justify-center" style={{ marginBottom: "10px" }}>

                                                                                        <Select
                                                                                            id="deduction_type"
                                                                                            name="deduction_type"
                                                                                            isClearable
                                                                                            isSearchable
                                                                                            options={[
                                                                                                { value: "deduction", label: "Deduction Only" },
                                                                                                { value: "withheldDeduction", label: "Withheld Deduction Only" },
                                                                                                // { value: "both", label: "For Both" },
                                                                                            ]}
                                                                                            value={[
                                                                                                { value: "deduction", label: "Deduction Only" },
                                                                                                { value: "withheldDeduction", label: "Withheld Deduction Only" },
                                                                                            ].find((opt) => opt.value === data.deduction_type) || null}
                                                                                            onChange={(selectedOption) =>
                                                                                                handlePreviousYearReleaseInputChange(
                                                                                                    {
                                                                                                        target: {
                                                                                                            name: "deduction_type",
                                                                                                            value: selectedOption ? selectedOption.value : "",
                                                                                                        },
                                                                                                    },
                                                                                                    index
                                                                                                )
                                                                                            }
                                                                                            placeholder="Select Deduction Type"
                                                                                            styles={CSSForSelectModern10VWWidth}
                                                                                        />
                                                                                    </div>
                                                                                    {errors[`${index}-previous_month_releasing_heading`] && (
                                                                                        <span className="error-message font-size-text">
                                                                                            {errors[`${index}-previous_month_releasing_heading`]}
                                                                                        </span>
                                                                                    )}

                                                                                    <div className="flex-row justify-center" style={{ marginBottom: "10px" }}>
                                                                                        <Select
                                                                                            id="deduction_id"
                                                                                            name="deduction_id"
                                                                                            isClearable
                                                                                            isSearchable
                                                                                            isDisabled={!data.previous_invoice_id}
                                                                                            options={
                                                                                                data.previous_invoice_id
                                                                                                    ? (data.deduction_type === "deduction"
                                                                                                        ? deductionAndBoth
                                                                                                        : data.deduction_type === "withheldDeduction"
                                                                                                            ? withheldAndBoth
                                                                                                            : data.deduction_type === "both"
                                                                                                                ? matchedBothDeduction
                                                                                                                : []
                                                                                                    )
                                                                                                        ?.filter((i) => i.invoice_id === data.previous_invoice_id)
                                                                                                        .map((i) => ({
                                                                                                            value: i.id,
                                                                                                            label: `${i.deduction_reason}/${i.invoice_type}`,
                                                                                                        }))
                                                                                                    : []
                                                                                            }
                                                                                            value={
                                                                                                (data.previous_invoice_id
                                                                                                    ? (data.deduction_type === "deduction"
                                                                                                        ? deductionAndBoth
                                                                                                        : data.deduction_type === "withheldDeduction"
                                                                                                            ? withheldAndBoth
                                                                                                            : data.deduction_type === "both"
                                                                                                                ? matchedBothDeduction
                                                                                                                : []
                                                                                                    )
                                                                                                        ?.filter((i) => i.invoice_id === data.previous_invoice_id)
                                                                                                        .map((i) => ({
                                                                                                            value: i.id,
                                                                                                            label: `${i.deduction_reason}/${i.invoice_type}`,
                                                                                                        }))
                                                                                                    : []
                                                                                                )?.find((opt) => opt.value === data.deduction_id) || null
                                                                                            }
                                                                                            onChange={(selectedOption) =>
                                                                                                handlePreviousYearReleaseInputChange(
                                                                                                    {
                                                                                                        target: {
                                                                                                            name: "deduction_id",
                                                                                                            value: selectedOption ? selectedOption.value : "",
                                                                                                        },
                                                                                                    },
                                                                                                    index
                                                                                                )
                                                                                            }
                                                                                            placeholder={data.previous_invoice_id ? "Select Deduction Data" : "Select Invoice First"}
                                                                                            styles={CSSForSelectModern15VWWidth}
                                                                                        />

                                                                                    </div>
                                                                                    {errors[`${index}-previous_month_releasing_heading`] && (
                                                                                        <span className="error-message font-size-text">
                                                                                            {errors[`${index}-previous_month_releasing_heading`]}
                                                                                        </span>
                                                                                    )}

                                                                                    <div className="form-field" style={{ marginBottom: "10px" }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            name="escalation_percentage"
                                                                                            id="escalation_percentage"
                                                                                            placeholder="Escalation %"
                                                                                            value={data.escalation_percentage}
                                                                                            onChange={(e) => handlePreviousYearReleaseInputChange(e, index)}
                                                                                            className="width-5vw"

                                                                                        />
                                                                                    </div>
                                                                                    {errors[`${index}-escalation_percentage`] && (
                                                                                        <span className="error-message font-size-text">
                                                                                            {errors[`${index}-escalation_percentage`]}
                                                                                        </span>
                                                                                    )}
                                                                                </div> : <>
                                                                                    <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                        <h6 className="text-center">Select Previous Invoice First</h6>
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }

                                                                </td>


                                                                {/* </td> */}
                                                                <td colspan="2">
                                                                    <div className="flex-row justify-between">
                                                                        <>
                                                                            {
                                                                                data.previous_invoice_id ?
                                                                                    <div className="form-field">


                                                                                        <input

                                                                                            type="text"
                                                                                            min={0}
                                                                                            name="description"
                                                                                            value={data.description}
                                                                                            onChange={(e) => handlePreviousYearReleaseInputChange(e, index)}
                                                                                            placeholder="Enter Releasing Description"
                                                                                            className=" width-20vw text-start"
                                                                                        />
                                                                                        {errors[`${index}-description`] && (
                                                                                            <span className="error-message font-size-text">
                                                                                                {errors[`${index}-description`]}
                                                                                            </span>
                                                                                        )}


                                                                                    </div> : ""

                                                                            }
                                                                        </>

                                                                        <div className="flex-row" style={{ width: !data.previous_invoice_id && "100%" }}>
                                                                            <>
                                                                                {
                                                                                    data.previous_invoice_id ?
                                                                                        <>
                                                                                            {data.deduction_type === "deduction" &&
                                                                                                <div className="form-field">
                                                                                                    <input

                                                                                                        type="number"
                                                                                                        min={0}
                                                                                                        name="deduction_amount"
                                                                                                        value={data.deduction_amount}
                                                                                                        onChange={(e) => handlePreviousYearReleaseInputChange(e, index)}
                                                                                                        placeholder="Enter Amount"
                                                                                                        style={{ float: "right" }}

                                                                                                        className=" width-10vw text-end"
                                                                                                    />
                                                                                                    {errors[`${index}-deduction_amount`] && (
                                                                                                        <span className="error-message font-size-text">
                                                                                                            {errors[`${index}-deduction_amount`]}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>

                                                                                            }
                                                                                            {data.deduction_type === "withheldDeduction" &&
                                                                                                <>
                                                                                                    <input

                                                                                                        type="number"
                                                                                                        min={0}
                                                                                                        name="withheld_release_amount"
                                                                                                        value={data.withheld_release_amount}
                                                                                                        onChange={(e) => handlePreviousYearReleaseInputChange(e, index)}
                                                                                                        placeholder="Enter Amount"
                                                                                                        className="form-input width-10vw text-end"
                                                                                                    />
                                                                                                    {errors[`${index}-withheld_release_amount`] && (
                                                                                                        <span className="error-message font-size-text">
                                                                                                            {errors[`${index}-withheld_release_amount`]}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </>

                                                                                            }  </> :
                                                                                        <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                            <h6 className="text-center">Select Previous Invoice First</h6>
                                                                                        </div>
                                                                                }
                                                                            </>
                                                                            {index === PreviousYearReleaseData.length - 1 && (
                                                                                <button
                                                                                    title="Remove Document"
                                                                                    onClick={() => handleRemoveDocument(index)}
                                                                                    className="file-clear clear-button2"
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            )}

                                                                        </div>


                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {/* <tr >

                                                        <td colspan="2" className=" ">Add Deduction Fields</td>

                                                        <td colspan="2" className="">
                                                            <button title="Add Document" className="upload-svg" style={{ float: "inline-end" }} onClick={handleDeductionData}>
                                                                <AddwithWhiteCircle /> Deduction Fields
                                                            </button>
                                                        </td>
                                                    </tr> */}
                                                        <tr >

                                                            <td colspan="2" className=" ">Add Deductions</td>

                                                            <td colspan="2" className="">

                                                                <button
                                                                    title="Deductions"
                                                                    className="btn-animated"
                                                                    onClick={handleDeductionData}
                                                                    style={{ float: "inline-end" }}

                                                                >
                                                                    <div className="btn-content">
                                                                        <PlusCircle size={16} />
                                                                        <span>Deductions</span>
                                                                    </div>
                                                                    <div className="btn-ripple"></div>
                                                                </button>

                                                            </td>
                                                        </tr>
                                                        {deductionData.map((data, index) => (
                                                            <tr >

                                                                <td colspan="1">
                                                                    <div className="flex-row " style={{ marginBottom: "10px" }}>
                                                                        <Select
                                                                            id="invoice_type"
                                                                            name="invoice_type"
                                                                            isClearable
                                                                            isSearchable
                                                                            options={[
                                                                                { value: "deduction", label: "Deduction Only" },
                                                                                { value: "withheldDeduction", label: "Withheld Deduction Only" },
                                                                                // { value: "both", label: "For Both" },
                                                                            ]}
                                                                            value={[
                                                                                { value: "deduction", label: "Deduction Only" },
                                                                                { value: "withheldDeduction", label: "Withheld Deduction Only" },
                                                                            ].find((opt) => opt.value === data.invoice_type) || null}
                                                                            onChange={(selectedOption) =>
                                                                                handleDeductionInputChange(
                                                                                    {
                                                                                        target: {
                                                                                            name: "invoice_type",
                                                                                            value: selectedOption ? selectedOption.value : "",
                                                                                        },
                                                                                    },
                                                                                    index
                                                                                )
                                                                            }
                                                                            placeholder="Select Deduction Type"
                                                                            styles={CSSForSelectModern15VWWidth}
                                                                        />

                                                                    </div>
                                                                    {errors[`${index}-invoice_type`] && (
                                                                        <span className="error-message font-size-text">
                                                                            {errors[`${index}-invoice_type`]}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                                <td colspan="1">

                                                                    {data.invoice_type === "deduction" ?
                                                                        <>
                                                                            <div className="form-field" style={{ marginBottom: "10px" }}>
                                                                                <textarea

                                                                                    type="text"
                                                                                    name="deduction_reason"
                                                                                    value={data.deduction_reason}
                                                                                    onChange={(e) => handleDeductionInputChange(e, index)}
                                                                                    placeholder="Enter Deduction Reason"
                                                                                    className="form-input width-20vw"
                                                                                    style={{ marginBottom: "10px" }}
                                                                                />
                                                                            </div>
                                                                            {errors[`${index}-deduction_reason`] && (
                                                                                <span className="error-message font-size-text">
                                                                                    {errors[`${index}-deduction_reason`]}
                                                                                </span>
                                                                            )}
                                                                        </> :
                                                                        data.invoice_type === "withheldDeduction" ?
                                                                            <>
                                                                                <div className="form-field" style={{ marginBottom: "10px" }}>
                                                                                    <textarea

                                                                                        type="text"
                                                                                        name="withheld_deduction_reason"
                                                                                        value={data.withheld_deduction_reason}
                                                                                        onChange={(e) => handleDeductionInputChange(e, index)}
                                                                                        placeholder="Enter Withheld Deduction Reason"
                                                                                        className="form-input width-20vw "
                                                                                        style={{ marginBottom: "10px" }}
                                                                                    />
                                                                                </div>
                                                                                {errors[`${index}-withheld_deduction_reason`] && (
                                                                                    <span className="error-message font-size-text">
                                                                                        {errors[`${index}-withheld_deduction_reason`]}
                                                                                    </span>
                                                                                )}
                                                                            </> : <>
                                                                                <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                    <h6 className="text-center">Select Deduction Type First</h6>
                                                                                </div>
                                                                            </>
                                                                    }

                                                                </td>

                                                                <td colspan="2">
                                                                    <div className="flex-row justify-between" style={{ float: "right" }}
                                                                    >
                                                                        <>
                                                                            {
                                                                                data.invoice_type === "deduction" ?
                                                                                    <div className="form-field" style={{ marginBottom: "10px" }}>

                                                                                        <input

                                                                                            type="number"
                                                                                            min={0}
                                                                                            name="deduction_amount"
                                                                                            value={data.deduction_amount === 0 ? "" : data.deduction_amount}
                                                                                            onChange={(e) => handleDeductionInputChange(e, index)}
                                                                                            placeholder="Enter Deduction Amount"
                                                                                            className=" width-20vw text-end"
                                                                                        />
                                                                                        {errors[`${index}-deduction_amount`] && (
                                                                                            <span className="error-message font-size-text">
                                                                                                {errors[`${index}-deduction_amount`]}
                                                                                            </span>
                                                                                        )}
                                                                                    </div> :
                                                                                    data.invoice_type === "withheldDeduction" ?
                                                                                        <div className="form-field" style={{ marginBottom: "10px" }}>

                                                                                            <input

                                                                                                type="number"
                                                                                                min={0}
                                                                                                name="withheld_deduction_amount"
                                                                                                value={data.withheld_deduction_amount === 0 ? "" : data.withheld_deduction_amount}
                                                                                                onChange={(e) => handleDeductionInputChange(e, index)}
                                                                                                placeholder="Enter Withheld Deduction Amount"
                                                                                                className="width-20vw text-end"
                                                                                            />
                                                                                            {errors[`${index}-withheld_deduction_amount`] && (
                                                                                                <span className="error-message font-size-text">
                                                                                                    {errors[`${index}-withheld_deduction_amount`]}
                                                                                                </span>
                                                                                            )}
                                                                                        </div> : <>
                                                                                            <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                                <h6 className="text-center">Select Deduction Type First</h6>
                                                                                            </div>
                                                                                        </>
                                                                            }
                                                                        </>


                                                                        {index === deductionData.length - 1 && (
                                                                            <button
                                                                                title="Remove Document"
                                                                                onClick={() => handleRemoveDeductionfield(index)}
                                                                                className="file-clear clear-button2"
                                                                            >
                                                                                X
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr >



                                                            <td colspan="2" className=" ">Net Amount<span className="required">(Read-Only)</span></td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="net_ammount"
                                                                        placeholder="Enter Amount"
                                                                        style={{ float: "right" }}
                                                                        value={formData.net_ammount}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={`width-30vw text-end ${errors.net_ammount ? ' is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {errors.net_ammount && (
                                                                    <div className="error-message font-size-text">{errors.net_ammount}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" ">Add: GST @{formData.gst_18_percentage}%<span className="required">(Read-Only)</span></td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>

                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="gst_amount"
                                                                        placeholder="Enter Amount"
                                                                        value={formData.gst_amount}
                                                                        style={{ float: "right" }}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={`width-30vw text-end ${errors.gst_amount ? ' is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {errors.gst_amount && (
                                                                    <div className="error-message font-size-text">{errors.gst_amount}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" text-bold">Gross Bill Amount (B)<span className="required">(Read-Only)</span></td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="gross_bill_ammount_B"
                                                                        placeholder="Enter Amount"
                                                                        style={{ float: "right" }}
                                                                        value={formData.gross_bill_ammount_B}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={`width-30vw text-end text-bold ${errors.gross_bill_ammount_B ? ' is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {errors.gross_bill_ammount_B && (
                                                                    <div className="error-message font-size-text">{errors.gross_bill_ammount_B}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" text-bold">Deductions:</td>
                                                            <td colspan="2"> </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className="">TDS Deducted @ {formData.tds_it_percentage}% of Net Amount<span className="required">(Read-Only)</span></td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="tds_it_amount"
                                                                        placeholder="Enter Amount"
                                                                        style={{ float: "right" }}
                                                                        value={formData.tds_it_amount}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={`width-30vw text-end ${errors.tds_it_amount ? ' is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {errors.tds_it_amount && (
                                                                    <div className="error-message font-size-text">{errors.tds_it_amount}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" ">GST (TDS) @ {formData.gst_tds_2_percentage}%<span className="required">(Read-Only)</span> </td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>

                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="tds_gst_amount"
                                                                        placeholder="Enter Amount"
                                                                        style={{ float: "right" }}
                                                                        value={formData.tds_gst_amount}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={`width-30vw text-end ${errors.tds_gst_amount ? ' is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {errors.tds_gst_amount && (
                                                                    <div className="error-message font-size-text">{errors.tds_gst_amount}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" ">GST Withheld due to Non Submission of Proof<span className="required"></span> </td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>

                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="withheld_gst_amount"
                                                                        placeholder="Enter Amount"
                                                                        style={{ float: "right" }}
                                                                        value={formData.withheld_gst_amount}
                                                                        onChange={handleInputChange}
                                                                        className={`width-30vw text-end ${errors.withheld_gst_amount ? ' is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {errors.withheld_gst_amount && (
                                                                    <div className="error-message font-size-text">{errors.withheld_gst_amount}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        {/* <tr >

                                                        <td colspan="2" className=" ">Add Withheld Deduction Fields</td>

                                                        <td colspan="2" className="">
                                                            <button title="Add Document" className="upload-svg" style={{ float: "inline-end" }} onClick={handleWithheldDeductionAdd}>
                                                                <AddwithWhiteCircle /> Withheld Deduction Fields
                                                            </button>
                                                        </td>
                                                    </tr> */}
                                                        {WithheldDeductionData.map((data, index) => (
                                                            <tr >

                                                                <td colspan="1">

                                                                    <select
                                                                        id="previous_invoice_id"
                                                                        name="previous_invoice_id"
                                                                        value={data.previous_invoice_id}
                                                                        onChange={(e) => handleWithhelddeductionInputChange(e, index)}
                                                                        className="form-input width-10vw"

                                                                    >
                                                                        <option value="" title='Select Invoice Number'>Select Previous Invoice</option>
                                                                        {invoiceList?.map((i, index) => (
                                                                            <option key={index} value={i.id} title='Select Previous Invoice'>
                                                                                {i.invoice_number}
                                                                            </option>
                                                                        ))
                                                                        }
                                                                    </select>
                                                                </td>
                                                                <td colspan="1">
                                                                    <div className="flex-row justify-center" style={{ marginBottom: "10px" }}>
                                                                        <textarea

                                                                            type="text"
                                                                            name="withheld_deduction_heading"
                                                                            value={data.withheld_deduction_heading}
                                                                            onChange={(e) => handleWithhelddeductionInputChange(e, index)}
                                                                            placeholder="Enter Withheld Deduction Heading"
                                                                            className="form-input width-20vw"
                                                                            style={{ marginBottom: "10px" }}
                                                                        />
                                                                    </div>
                                                                    {errors[`${index}-withheld_deduction_heading`] && (
                                                                        <span className="error-message font-size-text">
                                                                            {errors[`${index}-withheld_deduction_heading`]}
                                                                        </span>
                                                                    )}
                                                                </td>


                                                                {/* </td> */}
                                                                <td colspan="2">
                                                                    <div>
                                                                        <input

                                                                            type="number"
                                                                            min={0}
                                                                            name="withheld_deduction_amt"
                                                                            value={data.withheld_deduction_amt}
                                                                            onChange={(e) => handleWithhelddeductionInputChange(e, index)}
                                                                            placeholder="Withheld Release  Amount"
                                                                            className="form-input .width-10vw text-end"
                                                                        />
                                                                        {errors[`${index}-withheld_deduction_amt`] && (
                                                                            <span className="error-message font-size-text">
                                                                                {errors[`${index}-withheld_deduction_amt`]}
                                                                            </span>
                                                                        )}
                                                                        {index === WithheldDeductionData.length - 1 && (
                                                                            <button
                                                                                title="Remove Document"
                                                                                onClick={() => handleRemoveWithheldDeduction(index)}
                                                                                className="file-clear clear-button2"
                                                                            >
                                                                                X
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr >

                                                            <td colspan="2" className=" ">Total Deduction<span className="required">(Read-Only)</span> </td>
                                                            <td colspan="2">
                                                                <div className="form-field" style={{ float: "right" }}>

                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="total_deduction"
                                                                        placeholder="Enter Amount"
                                                                        style={{ float: "right" }}
                                                                        value={formData.total_deduction}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={`width-30vw text-end ${errors.total_deduction ? ' is-invalid' : ''}`}
                                                                    />
                                                                </div>
                                                                {errors.total_deduction && (
                                                                    <div className="error-message font-size-text">{errors.total_deduction}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr >

                                                            <td colspan="2" className=" ">Released Fields</td>

                                                            <td colspan="2" className="">


                                                                <button
                                                                    title=" Release Fields"
                                                                    className="btn-animated"
                                                                    onClick={handleWithheldReleaseAdd}
                                                                    style={{ float: "inline-end" }}

                                                                >
                                                                    <div className="btn-content">
                                                                        <PlusCircle size={16} />
                                                                        <span>Release Fields</span>
                                                                    </div>
                                                                    <div className="btn-ripple"></div>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        {WithheldRelease.map((data, index) => (
                                                            <tr >

                                                                <td colspan="1">

                                                                    <Select
                                                                        id="previous_invoice_id"
                                                                        name="previous_invoice_id"
                                                                        isClearable
                                                                        isSearchable
                                                                        options={filteredDataPayment?.map((i) => ({
                                                                            value: i.id,
                                                                            label: `Invoice No.: ${i.invoice_number}`,
                                                                        }))}
                                                                        value={filteredDataPayment
                                                                            ?.map((i) => ({
                                                                                value: i.id,
                                                                                label: `Invoice No.: ${i.invoice_number}`,
                                                                            }))
                                                                            .find((opt) => opt.value === data.previous_invoice_id) || null}
                                                                        onChange={(selectedOption) =>
                                                                            handleWithheldReleaseInputChange(
                                                                                {
                                                                                    target: {
                                                                                        name: "previous_invoice_id",
                                                                                        value: selectedOption ? selectedOption.value : "",
                                                                                    },
                                                                                },
                                                                                index
                                                                            )
                                                                        }
                                                                        placeholder="Select Previous Invoice"
                                                                        styles={CSSForSelectModern15VWWidth}
                                                                    />

                                                                    {/* <select
                                                                        id="previous_invoice_id"
                                                                        name="previous_invoice_id"
                                                                        value={data.previous_invoice_id}
                                                                        onChange={(e) => handleWithheldReleaseInputChange(e, index)}
                                                                        className="form-input width-15vw"

                                                                    >
                                                                        <option value="" title='Select Invoice Number'>Select Previous Invoice</option>
                                                                        {filteredDataPayment?.map((i, index) => (
                                                                            <option key={index} value={i.id} title='Select Previous Invoice'>
                                                                                Invoice No.: {i.invoice_number}
                                                                            </option>
                                                                        ))
                                                                        }
                                                                    </select> */}
                                                                </td>
                                                                <td colspan="1">
                                                                    {

                                                                        <>

                                                                            {data.previous_invoice_id ?
                                                                                <>
                                                                                    <div className="flex-row justify-center" style={{ margin: "10px, 0px" }}>

                                                                                        <Select
                                                                                            id="deduction_id"
                                                                                            name="deduction_id"
                                                                                            isClearable
                                                                                            isSearchable
                                                                                            isDisabled={!data.previous_invoice_id}
                                                                                            options={
                                                                                                data.previous_invoice_id
                                                                                                    ? bothDeductions
                                                                                                        ?.filter((i) => i.invoice_id === data.previous_invoice_id)
                                                                                                        .map((i) => ({
                                                                                                            value: i.id,
                                                                                                            label: `${i.deduction_reason}${i.withheld_deduction_reason}/${i.invoice_type}`,
                                                                                                        }))
                                                                                                    : []
                                                                                            }
                                                                                            value={
                                                                                                (data.previous_invoice_id
                                                                                                    ? bothDeductions
                                                                                                        ?.filter((i) => i.invoice_id === data.previous_invoice_id)
                                                                                                        .map((i) => ({
                                                                                                            value: i.id,
                                                                                                            label: `${i.deduction_reason}${i.withheld_deduction_reason}/${i.invoice_type}`,
                                                                                                        }))
                                                                                                    : []
                                                                                                )?.find((opt) => opt.value === data.deduction_id) || null
                                                                                            }
                                                                                            onChange={(selectedOption) =>
                                                                                                handleWithheldReleaseInputChange(
                                                                                                    {
                                                                                                        target: {
                                                                                                            name: "deduction_id",
                                                                                                            value: selectedOption ? selectedOption.value : "",
                                                                                                        },
                                                                                                    },
                                                                                                    index
                                                                                                )
                                                                                            }
                                                                                            placeholder={data.previous_invoice_id ? "Select Deduction Data" : "Select Previous Invoice First"}
                                                                                            styles={CSSForSelectModern}
                                                                                        />
                                                                                    </div> </> : <>
                                                                                    <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                        <h6 className="text-center">Select Previous Invoice First</h6>
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }
                                                                </td>


                                                                {/* </td> */}
                                                                <td colspan="2">
                                                                    <div className="flex-row justify-between">
                                                                        <>
                                                                            {
                                                                                data.previous_invoice_id ?
                                                                                    <div className="form-field flex-column">



                                                                                        <input

                                                                                            type="text"
                                                                                            min={0}
                                                                                            name="description"
                                                                                            value={data.description}
                                                                                            onChange={(e) => handleWithheldReleaseInputChange(e, index)}
                                                                                            placeholder="Enter Releasing Description"
                                                                                            className=" width-25vw text-start"
                                                                                        />
                                                                                        {errors[`${index}-description`] && (
                                                                                            <span className="error-message font-size-text">
                                                                                                {errors[`${index}-description`]}
                                                                                            </span>
                                                                                        )}



                                                                                    </div> : ""

                                                                            }
                                                                        </>
                                                                        <div className="flex-row" style={{ width: !data.previous_invoice_id && "100%" }}>
                                                                            <>
                                                                                {
                                                                                    data.previous_invoice_id ?
                                                                                        <>
                                                                                            <div className="form-field flex-column">

                                                                                                <input

                                                                                                    type="number"
                                                                                                    min={0}
                                                                                                    name="withheld_release_amount"
                                                                                                    value={data.withheld_release_amount}
                                                                                                    onChange={(e) => handleWithheldReleaseInputChange(e, index)}
                                                                                                    placeholder="Enter Amount"
                                                                                                    className=" width-10vw text-end"
                                                                                                />
                                                                                                {errors[`${index}-withheld_release_amount`] && (
                                                                                                    <span className="error-message font-size-text">
                                                                                                        {errors[`${index}-withheld_release_amount`]}
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </> :
                                                                                        <div className="flex-row justify-center" style={{ height: "80px", width: "100%" }}>

                                                                                            <h6 className="text-center">Select Previous Invoice First</h6>
                                                                                        </div>
                                                                                }
                                                                            </>
                                                                            {index === WithheldRelease.length - 1 && (
                                                                                <button
                                                                                    title="Remove Document"
                                                                                    onClick={() => handleWithheldRemoveField(index)}
                                                                                    className="file-clear clear-button2"
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            )}


                                                                        </div>

                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr >
                                                            <td colspan="2" className=" text-bold">Net Payable Amount<span className="required">(Read-Only)</span></td>
                                                            <td colspan="2">
                                                                <div className="form-field flex-column" style={{ float: "right" }}>

                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        name="net_payable_amount"
                                                                        placeholder="Enter Amount"
                                                                        style={{ float: "right" }}
                                                                        value={formData.net_payable_amount}
                                                                        readOnly // Make it read-only to prevent manual editing
                                                                        className={`width-30vw text-end text-bold ${errors.net_payable_amount ? ' is-invalid' : ''}`}
                                                                    />
                                                                    {errors.net_payable_amount && (
                                                                        <div className="error-message font-size-text">{errors.net_payable_amount}</div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>

                                    <div className="form-actions">
                                        <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                                        <button type="button" className="btn-primaryy" onClick={handleFormSubmit} disabled={loading}>
                                            <UploadIcon />
                                            <span>{loading ? 'Adding...' : 'Add'}</span>
                                        </button>
                                    </div>




                                    <p className="error-message font-size-text">
                                        {isSubmitted && Object.keys(errors).length > 0 && (
                                            Object.keys(errors).length > 5 ? (
                                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                                            ) : (

                                                <h6 className="text-center">
                                                    {Object.keys(errors).map((field) =>
                                                        field.charAt(0).toUpperCase() + field.slice(1)
                                                    ).join(', ') + ' are required!'}
                                                </h6>
                                            )
                                        )}
                                    </p>
                                </div>
                                <ToastContainer
                                    position="top-center"
                                    autoClose={1000}
                                    hideProgressBar={false}
                                    newestOnTop={true}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                />
                            </Modal.Body>
                        </Modal > : ""
            }
        </>
    )
}

// const PaymentReceipt = ({ p_id, invoice_id, invoice_num, month, year, ref, invoiceData }) => {


//     const [employees, setEmployees] = useState([]);
//     const role = sessionStorage.getItem("sitemanagement_role");
//     const project = sessionStorage.getItem("sitemanagement_project");
//     const [employeeDeduction, setEmployeeDeduction] = useState([]);
//     const [projectbyid, setprojectbyid] = useState({});


//     const getProjectById = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/project/${p_id ? p_id : project}/`);
//             setprojectbyid(response.data);
//         } catch (error) {
//             console.error("Error fetching project by ID:", error);
//             handleErrorToast(error);
//         }
//     };
//     useEffect(() => {
//         getProjectById();
//     }, [p_id, project]);

//     const getEmployeeInvoice = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceEmployee/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const data = res.data;
//             const data2 = response2.data;


//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedEmployeeData = isAnyBoqJsonNull ? data2 : data;
//             setEmployees(selectedEmployeeData);
//         } catch (err) { }
//     };
//     const getEmployeeInvoiceDeduction = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoiceemployeefiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setEmployeeDeduction(data);



//         } catch (err) { }
//     };



//     useEffect(() => {
//         getEmployeeInvoice();
//     }, [p_id, month, year, project, invoice_id]);
//     useEffect(() => {
//         getEmployeeInvoiceDeduction();
//     }, [invoice_id]);

//     const [transportations, setTransportations] = useState([]);
//     const [transportDeduction, setTransportDeduction] = useState([]);


//     const getTransportationInvoice = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceTransoprt/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const data = res.data;
//             const data2 = response2.data;

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedTransportationData = isAnyBoqJsonNull ? data2 : data;
//             setTransportations(selectedTransportationData);
//         } catch (err) { }
//     };

//     const getTransportDeduction = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoicetransportationfiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setTransportDeduction(data);



//         } catch (err) { }
//     };
//     useEffect(() => {
//         getTransportDeduction();
//     }, [invoice_id]);


//     useEffect(() => {

//         // getdocument();
//         getTransportationInvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const [dutyTravelinvoice, setDutyTravelinvoice] = useState([]);
//     const [dutyTravelDeduction, setDutyTravelDeduction] = useState([]);

//     const getDutyTravelDeduction = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoicedutytravelfiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setDutyTravelDeduction(data);



//         } catch (err) { }
//     };
//     useEffect(() => {
//         getDutyTravelDeduction();
//     }, [invoice_id]);


//     const getDutyTravelinvoice = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceDutyTravel/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const dutydata = res.data;
//             const dutydata2 = response2.data;

//             const isBoqJsonNull = dutydata.length !== 0 && dutydata.every(item => item.boq_json === null);

//             const selectedDutyData = isBoqJsonNull ? dutydata2 : dutydata;

//             setDutyTravelinvoice(selectedDutyData);
//         } catch (err) { }
//     };




//     useEffect(() => {

//         // getdocument();
//         getDutyTravelinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const [officeRentinvoice, setOfficeRentinvoice] = useState([]);
//     const [officeRentlDeduction, setofficeRentlDeduction] = useState([]);

//     const getofficeRentlDeduction = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoiceofficerentfiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setofficeRentlDeduction(data);



//         } catch (err) { }
//     };
//     useEffect(() => {
//         getofficeRentlDeduction();
//     }, [invoice_id]);

//     const getOfficeRentinvoice = async () => {

//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceOfficeRent/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const data = res.data;
//             const data2 = response2.data;

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedTransportationData = isAnyBoqJsonNull ? data2 : data;
//             setOfficeRentinvoice(selectedTransportationData);
//         } catch (err) { }
//     };

//     useEffect(() => {

//         // getdocument();
//         getOfficeRentinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const [officeSuppliesinvoice, setOfficeSuppliesinvoice] = useState([]);
//     const [officeSupplieslDeduction, setofficeSupplieslDeduction] = useState([]);

//     const getofficeSupplieslDeduction = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoiceofficesuppliesfiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setofficeSupplieslDeduction(data);



//         } catch (err) { }
//     };
//     useEffect(() => {
//         getofficeSupplieslDeduction();
//     }, [invoice_id]);


//     const getOfficeSuppliesinvoice = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceOfficeSupplies/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const data = res.data;
//             const data2 = response2.data;

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedData = isAnyBoqJsonNull ? data2 : data;
//             setOfficeSuppliesinvoice(selectedData);
//         } catch (err) { }
//     };

//     useEffect(() => {

//         // getdocument();
//         getOfficeSuppliesinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);



//     const [officeFurnitureinvoice, setOfficeFurnitureinvoice] = useState([]);
//     const [officefurnitureDeduction, setofficefurnitureDeduction] = useState([]);

//     const getofficefurnitureDeduction = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setofficefurnitureDeduction(data);



//         } catch (err) { }
//     };
//     useEffect(() => {
//         getofficefurnitureDeduction();
//     }, [invoice_id]);


//     const getOfficeFurnitureinvoice = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceOfficeFurnitureAndEquipment/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const data = res.data;
//             const data2 = response2.data;

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.invoice_amount === null);


//             const selectedData = isAnyBoqJsonNull ? data2 : data;
//             setOfficeFurnitureinvoice(selectedData);
//         } catch (err) { }
//     };

//     useEffect(() => {

//         // getdocument();
//         getOfficeFurnitureinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const [reportsPrinttinvoice, setReportsPrinttinvoice] = useState([]);
//     const [reportsAndDocumentsDeduction, setreportsAndDocumentsDeduction] = useState([]);

//     const getreportsAndDocumentsDeduction = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setreportsAndDocumentsDeduction(data);



//         } catch (err) { }
//     };
//     useEffect(() => {
//         getreportsAndDocumentsDeduction();
//     }, [invoice_id]);
//     const getReportsPrinttinvoice = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceReportsAndDocumentPrinting/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const data = res.data;
//             const data2 = response2.data;

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedData = isAnyBoqJsonNull ? data2 : data;
//             setReportsPrinttinvoice(selectedData);
//         } catch (err) { }
//     };




//     useEffect(() => {

//         // getdocument();
//         getReportsPrinttinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);


//     const [roadSurveyinvoice, setRoadSurveyinvoice] = useState([]);
//     const [roadSurveyDeductions, setroadSurveyDeductions] = useState([]);

//     const getroadSurveyDeductions = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfiltermonthyear/${invoice_id}/null/null/`
//             );
//             const data = res.data;
//             setroadSurveyDeductions(data);



//         } catch (err) { }
//     };
//     useEffect(() => {
//         getroadSurveyDeductions();
//     }, [invoice_id]);

//     const getRoadSurveyinvoice = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id ? p_id : project}/${month}/${year}/`);
//             const response2 = await axios.get(
//                 `${BASE_URL}/siteproject/oldlogInvoiceRoadSurveyEquipment/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
//             );
//             const data = res.data;
//             const data2 = response2.data;

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedData = isAnyBoqJsonNull ? data2 : data;
//             setRoadSurveyinvoice(selectedData);
//         } catch (err) { }
//     };


//     const [contigency, setContigency] = useState([]);

//     const getContigency = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/invoicecontingenciesbyproject/${p_id ? p_id : project}/`
//             );
//             setContigency(res.data);
//         } catch (err) {
//             console.error("Error fetching consultant invoice data:", err);
//         }
//     };

//     useEffect(() => {
//         getContigency();

//     }, [p_id, project]);

//     useEffect(() => {

//         // getdocument();
//         getRoadSurveyinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const [calculateEmployeeTotal, setEmployeeTotal] = useState(0);
//     const [calculateEmployeeTotalSub, setEmployeeTotalSub] = useState(0);
//     const [calculateEmployeeTotalSupport, setEmployeeTotalSupport] = useState(0);
//     const [calculateEmployeeTotalDeductions, setEmployeeTotalDeductions] = useState(0);
//     const [calculateEmployeeTotalDeductionsSub, setEmployeeTotalDeductionsSub] = useState(0);
//     const [calculateEmployeeTotalDeductionsSupport, setEmployeeTotalDeductionsSupport] = useState(0);


//     useEffect(() => {
//         const filterKeyprof = employees.filter(item => item?.employee_details?.professional_type === "Key Professional")
//         const filterSubprof = employees.filter(item => item?.employee_details?.professional_type === "Sub Professional")
//         const filterSupport = employees.filter(item => item?.employee_details?.professional_type === "Support Staff")

//         const calculateCurrentAmount = calculateTotal(
//             filterKeyprof,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         const calculateCurrentAmountSub = calculateTotal(
//             filterSubprof,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         const calculateCurrentAmountSupport = calculateTotal(
//             filterSupport,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setEmployeeTotal(calculateCurrentAmount);
//         setEmployeeTotalSub(calculateCurrentAmountSub);
//         setEmployeeTotalSupport(calculateCurrentAmountSupport);
//     }, [employees]);
//     useEffect(() => {
//         const filterKeyprof = employeeDeduction.filter(item => item?.employee_details?.professional_type === "Key Professional")
//         const filterSubprof = employeeDeduction.filter(item => item?.employee_details?.professional_type === "Sub Professional")
//         const filterSupport = employeeDeduction.filter(item => item?.employee_details?.professional_type === "Support Staff")

//         const calculateCurrentAmount = calculateTotal(
//             filterKeyprof,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         const calculateCurrentAmountSub = calculateTotal(
//             filterSubprof,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         const calculateCurrentAmountSupport = calculateTotal(
//             filterSupport,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setEmployeeTotalDeductions(calculateCurrentAmount);
//         setEmployeeTotalDeductionsSub(calculateCurrentAmountSub);
//         setEmployeeTotalDeductionsSupport(calculateCurrentAmountSupport);
//     }, [employeeDeduction]);
//     const [calculatetransport, settransportTotal] = useState(0);
//     const [calculatetransportDeductions, settransportTotalDeductions] = useState(0);


//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             transportations,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         settransportTotal(calculateCurrentAmount);
//     }, [transportations]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             transportDeduction,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         settransportTotalDeductions(calculateCurrentAmount);
//     }, [transportDeduction]);


//     const [calculateDuty, setCalculateDuty] = useState(0);
//     const [calculateDutyDeductions, setCalculateDutyDeductions] = useState(0);

//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             dutyTravelDeduction,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateDutyDeductions(calculateCurrentAmount);
//     }, [dutyTravelDeduction]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             dutyTravelinvoice,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateDuty(calculateCurrentAmount);
//     }, [dutyTravelinvoice]);


//     const [calculateRent, setCalculaterent] = useState(0);
//     const [calculateRentDeductions, setCalculaterentDeductions] = useState(0);

//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             officeRentlDeduction,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculaterentDeductions(calculateCurrentAmount);
//     }, [officeRentlDeduction]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             officeRentinvoice,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculaterent(calculateCurrentAmount);
//     }, [officeRentinvoice]);

//     const [calculateSupplies, setCalculatesupplies] = useState(0);
//     const [calculateSuppliesDeductions, setCalculatesuppliesDeductions] = useState(0);


//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             officeSuppliesinvoice,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculatesupplies(calculateCurrentAmount);
//     }, [officeSuppliesinvoice]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             officeSupplieslDeduction,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculatesuppliesDeductions(calculateCurrentAmount);
//     }, [officeSupplieslDeduction]);


//     const [calculateFurniture, setCalculateFurniture] = useState(0)
//     const [calculateFurnitureDeductions, setCalculateFurnitureDeductions] = useState(0)

//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             officeFurnitureinvoice,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateFurniture(calculateCurrentAmount);
//     }, [officeFurnitureinvoice]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             officefurnitureDeduction,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateFurnitureDeductions(calculateCurrentAmount);
//     }, [officefurnitureDeduction]);


//     const [calculateReports, setCalculateReports] = useState(0)
//     const [calculateReportsDeductions, setCalculateReportsDeductions] = useState(0)

//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             reportsPrinttinvoice,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateReports(calculateCurrentAmount);
//     }, [reportsPrinttinvoice]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             reportsAndDocumentsDeduction,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateReportsDeductions(calculateCurrentAmount);
//     }, [reportsAndDocumentsDeduction]);


//     const [calculateRoadsurvey, setCalculateRoadSurvey] = useState(0);
//     const [calculateRoadsurveyDeductions, setCalculateRoadSurveyDeductions] = useState(0);


//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             roadSurveyinvoice,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateRoadSurvey(calculateCurrentAmount);
//     }, [roadSurveyinvoice]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             roadSurveyDeductions,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setCalculateRoadSurveyDeductions(calculateCurrentAmount);
//     }, [roadSurveyDeductions]);


//     const [calculatecintigeniousTotal, setContigeneousTotal] = useState(0);

//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             contigency,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         setContigeneousTotal(calculateCurrentAmount);
//     }, [contigency]);
//     useEffect(() => {
//         const calculateCurrentAmount = calculateTotal(
//             transportations,
//             (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
//         );
//         settransportTotal(calculateCurrentAmount);
//     }, [transportations]);



//     const [paymentData, setPaymentData] = useState();
//     const [deductionData, setDeductionData] = useState([]);

//     const [deductionPaymentData, setDeductionPAymentData] = useState([]);



//     const projectId = sessionStorage.getItem('sitemanagement_project');


//     const [releaseDataByProject, setreleaseDataByProject] = useState([]);





//     const getPaymentDeductionData = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/null/${invoice_id}/null/`);
//             setDeductionPAymentData(res.data);
//         } catch (error) {
//             console.error(error);

//         }
//     }
//     const getOtherDeductionData = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release-by-invoice/${invoice_id}/`);
//             setDeductionData(res.data);
//         } catch (error) {
//             console.error(error);

//         }
//     }
//     const getReleaseByProject = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//             setreleaseDataByProject(res.data);
//         } catch (error) {
//             console.error(error);

//         }
//     }

//     const getPayment = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/paymentrecievedfilter/${p_id ? p_id : projectId}/${month}/${year}/${invoice_num}/`);
//             setPaymentData(res.data[0]);

//         } catch (err) { }
//     };



//     useEffect(() => {

//         // getdocument();
//         getPayment();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [p_id, projectId, month, year, invoice_num, invoice_id]);

//     useEffect(() => {

//         getOtherDeductionData();
//         getPaymentDeductionData();
//         getReleaseByProject();
//     }, []);


//     const filterDeductionData = deductionPaymentData.filter(i => i.item_id === null || i.item_id === "null" || i.item_id === undefined);
//     const getDeductionIds = filterDeductionData.map(i => i.id);

//     const filterReleaseIds = deductionData.map(i => i.id);




//     return (
//         <div className='table-css-backgrounds' ref={ref}>
//             <div className="table-css-background">
//                 <h3 style={{ textAlign: "justify", fontSize: "15px" }}>{projectbyid?.project_name}</h3>

//                 <div className='consultant-heading'>
//                     <h6>Client Name: {projectbyid?.client_name}</h6>
//                     <h6>Consultant (AE): {projectbyid?.lead}{projectbyid?.jv ? ` JV with ${projectbyid?.jv}.` : ""}{projectbyid?.association ? ` Association with ${projectbyid?.association}` : ""}</h6>
//                     <h6>GSTIN No: {projectbyid?.gst_no}</h6>
//                     <h6>PAN No: {projectbyid?.pan_no}</h6>
//                     <h6>Bid Due Submission Date: {formatDateDD_MM_YYYY(projectbyid?.bid_due_date)}</h6>
//                     <div className='flex-row justify-between' style={{ width: "86vw" }}>
//                         <div>
//                             <h6>Agreement Date: {formatDateDD_MM_YYYY(projectbyid?.agreement_date)}</h6>
//                             <h6>Project Start Date: {formatDateDD_MM_YYYY(projectbyid?.commencement_date)}</h6>
//                         </div>
//                         <div>
//                             <h6>Date: {getMonthName(month)}-{year}</h6>
//                             <h6>Invoice Number: {invoice_num}</h6>
//                         </div>
//                     </div>
//                 </div>
//                 <div className='heads-div'>
//                     <h2>Payment Receipt <br /></h2>
//                     {!paymentData || Object.keys(paymentData).length === 0 ? (
//                         <div className="hide-on-print">
//                             <AddPaymentReceipt
//                                 p_id={p_id}
//                                 invoice_num={invoice_num}
//                                 invoice_id={invoice_id}
//                                 getPayment={getPayment}
//                                 project_id={projectId}
//                                 month={month}
//                                 year={year}
//                                 releaseByProject={releaseDataByProject}
//                                 calculateCurrentAmountSupport={calculateEmployeeTotalSupport}
//                                 calculateCurrentAmountSub={calculateEmployeeTotalSub}
//                                 calculateTotalEmployee={calculateEmployeeTotal}
//                                 calculateTotaltransport={calculatetransport}
//                                 calculateTotalDuty={calculateDuty}
//                                 calculateTotalRent={calculateRent}
//                                 calculateTotalSupplies={calculateSupplies}
//                                 calculateTotalReports={calculateReports}
//                                 calculatetotalFurniture={calculateFurniture}
//                                 calculateTotalSurevy={calculateRoadsurvey}
//                                 calculateCurrentAmountSupportDeductions={calculateEmployeeTotalDeductionsSupport}
//                                 calculateCurrentAmountSubDeductions={calculateEmployeeTotalDeductionsSub}
//                                 calculateTotalEmployeeDeductions={calculateEmployeeTotalDeductions}
//                                 calculateTotaltransportDeductions={calculatetransportDeductions}
//                                 calculateTotalDutyDeductions={calculateDutyDeductions}
//                                 calculateTotalRentDeductions={calculateRentDeductions}
//                                 calculateTotalSuppliesDeductions={calculateSuppliesDeductions}
//                                 calculateTotalReportsDeductions={calculateReportsDeductions}
//                                 calculatetotalFurnitureDeductions={calculateFurnitureDeductions}
//                                 calculateTotalSurevyDeductions={calculateRoadsurveyDeductions}
//                             />
//                         </div>
//                     ) :


//                         <>
//                             {(!["Checker", "SiteManagement"].includes(role) && true) ||
//                                 (role === "Checker" && !isMoreThan24Hours(paymentData.created_at)) ? (
//                                 <div className="hide-on-print">
//                                     <DeletePaymentrecipt i={paymentData?.id} getPaymentReceipt={getPayment} deductionData={deductionData} deductionIds={getDeductionIds} releaseIds={filterReleaseIds} />
//                                 </div>
//                             ) :
//                                 <div className="table-body flex-row hide-on-print">
//                                     Delete Button hides after 24 hrs
//                                 </div>
//                             }
//                         </>

//                     }


//                 </div>
//                 <div className="flex-row justify-center">
//                     <table className="nested-table-lightblue width-90vw payment">
//                         <thead>
//                             <tr>
//                                 <th rowSpan="" style={{ width: "10vw" }}>S.No</th>
//                                 <th colSpan="" className='align-center  width-20vw'>Particulars</th>
//                                 <th colSpan="" className='align-center  width-10vw'>Invoice Amount</th>
//                                 <th colSpan="" className='align-center  width-10vw'>Amount</th>
//                                 {/* <th colSpan="" className='align-center'>Deductions</th>
//                             <th colSpan="" className='align-center'>Total</th> */}

//                             </tr>


//                         </thead>
//                         <tbody>
//                             <React.Fragment>
//                                 <tr>
//                                     <td>1</td>
//                                     <td className="text-start">Remuneration for Local Professional Staff</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculateEmployeeTotal || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.local_professional_staff)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>2</td>
//                                     <td className="text-start">Transportation</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculatetransport || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.transport)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>3</td>
//                                     <td className="text-start">Duty Travels</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculateDuty || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.duty_travel)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>4</td>
//                                     <td className="text-start">Office Rent</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculateRent || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.office_rent)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>5</td>
//                                     <td className="text-start">Office Supplies, Utilities and Communications</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculateSupplies || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.office_supplies)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>6</td>
//                                     <td className="text-start">Office Furniture and Equipments</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculateFurniture || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.office_furniture)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>7</td>
//                                     <td className="text-start">Report and Document Printing</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculateReports || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.reports)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>8</td>
//                                     <td className="text-start">Road Survey Equipment</td>
//                                     <td className="text-end">{formatCurrencyIndian(calculateRoadsurvey || 0)}</td>
//                                     <td className="text-end">{formatCurrencyIndian(paymentData?.road_survey)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td>9</td>
//                                     <td className="text-start">Contingencies</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.contingencies)}</td>
//                                 </tr>
//                                 {deductionData
//                                     .filter(i => i.escalation_percentage === "")
//                                     .map((i, index) => (
//                                         <tr key={index}>
//                                             <td colSpan="2" className="text-start text-bold">{i.description}</td>
//                                             <td colSpan="2" className="text-end">{formatCurrencyIndian(i.deduction_amount ? i.deduction_amount : i.withheld_release_amount)}</td>
//                                         </tr>
//                                     ))
//                                 }
//                                 <tr>
//                                     <td colSpan="2" className="text-start">Sub Total(A)</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.total_bill_without_escalation)}</td>
//                                 </tr>

//                                 <tr>
//                                     <td colSpan="2" className="text-start">Add: Escalation ({Number(paymentData?.escalation_percentage ? paymentData?.escalation_percentage : "0")?.toFixed(0)}% of Subtotal)</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.escalation_amount)}</td>
//                                 </tr>
//                                 {deductionData
//                                     .filter(i => i.escalation_percentage)
//                                     .map((i, index) => (
//                                         <tr key={index}>
//                                             <td colSpan="2" className="text-start text-bold">{i.description}</td>
//                                             <td colSpan="2" className="text-end">{formatCurrencyIndian(i.deduction_amount ? i.deduction_amount : i.withheld_release_amount)}</td>
//                                         </tr>
//                                     ))
//                                 }
//                                 {deductionPaymentData
//                                     .filter(i => i.item_id === null && i.invoice_type === "deduction") // Filter empty values
//                                     .map((i, index) => (
//                                         <tr key={index}>
//                                             <td colSpan="2" className="text-start text-bold">{i.deduction_reason}</td>
//                                             <td colSpan="2" className="text-end">{formatCurrencyIndian(i.deduction_amount)}</td>
//                                         </tr>
//                                     ))
//                                 }
//                                 {deductionPaymentData
//                                     .filter(i => i.item_id === null && i.invoice_type === "withheldDeduction") // Filter empty values
//                                     .map((i, index) => (
//                                         <tr key={index}>
//                                             <td colSpan="2" className="text-start text-bold">{i.withheld_deduction_reason}</td>
//                                             <td colSpan="2" className="text-end">{formatCurrencyIndian(i.withheld_deduction_amount)}</td>
//                                         </tr>
//                                     ))
//                                 }


//                                 <tr>
//                                     <td colSpan="2" className="text-start text-bold">Net Amount</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.net_ammount)}</td>
//                                 </tr>

//                                 <tr>
//                                     <td colSpan="2" className="text-start">Add GST @{paymentData?.gst_18_percentage ? paymentData?.gst_18_percentage : "0"}%</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.gst_amount)}</td>
//                                 </tr>

//                                 <tr>
//                                     <td colSpan="2" className="text-start text-bold">Gross Bill Amount (B)</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.gross_bill_ammount_B)}</td>
//                                 </tr>

//                                 <tr>
//                                     <td colSpan="2" className="text-start text-bold ">Deductions:</td>
//                                     <td colSpan="2"></td>
//                                 </tr>
//                                 <tr>
//                                     <td colSpan="2" className="text-start">TDS deducted @{paymentData?.tds_it_percentage ? paymentData?.tds_it_percentage : "0"}%</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.tds_it_amount)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td colSpan="2" className="text-start">GST (TDS) @{paymentData?.gst_tds_2_percentage ? paymentData?.gst_tds_2_percentage : "0"}%</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.tds_gst_amount)}</td>
//                                 </tr>
//                                 <tr>
//                                     <td colSpan="2" className="text-start">GST Withheld due to Non Submission of Proof</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.withheld_gst_amount)}</td>
//                                 </tr>
//                                 {deductionData
//                                     .filter(i => i.withheld_deduction_heading?.trim() && i.withheld_deduction_amt) // Filter empty values
//                                     .map((i, index) => (
//                                         <tr key={index}>
//                                             <td colSpan="2" className="text-start text-bold">{i.withheld_deduction_heading}</td>
//                                             <td colSpan="2" className="text-end">{formatCurrencyIndian(i.withheld_deduction_amt)}</td>
//                                         </tr>
//                                     ))
//                                 }
//                                 <tr>
//                                     <td colSpan="2" className="text-start">Total Deductions</td>
//                                     <td colSpan="2" className="text-end">{formatCurrencyIndian(paymentData?.total_deduction)}</td>
//                                 </tr>
//                                 {releaseDataByProject
//                                     .filter(i => i.deduction_data?.item_id === null) // Filter empty values
//                                     .map((i, index) => (
//                                         <tr key={index}>
//                                             <td colSpan="2" className="text-start text-bold">{i.description}</td>
//                                             <td colSpan="2" className="text-end">{formatCurrencyIndian(i.deduction_amount || i.withheld_release_amount)}</td>
//                                         </tr>
//                                     ))
//                                 }
//                                 <tr>
//                                     <td colSpan="2" className="text-start text-bold">Net Payable Amount</td>
//                                     <td colSpan="2" className="text-end text-bold">{formatCurrencyIndian(paymentData?.net_payable_amount)}</td>
//                                 </tr>
//                             </React.Fragment>
//                         </tbody>

//                     </table>
//                 </div>

//             </div>

//         </div>
//     );
// };

const PaymentReceipt = ({ p_id, invoice_id, invoice_num, month, year, ref, invoiceData }) => {


    const [employees, setEmployees] = useState([]);
    const role = sessionStorage.getItem("sitemanagement_role");
    const project = sessionStorage.getItem("sitemanagement_project");
    const [employeeDeduction, setEmployeeDeduction] = useState([]);
    const [projectbyid, setprojectbyid] = useState({});


    const getProjectById = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/project/${p_id ? p_id : project}/`);
            setprojectbyid(response.data);
        } catch (error) {
            console.error("Error fetching project by ID:", error);
            handleErrorToast(error);
        }
    };
    useEffect(() => {
        getProjectById();
    }, [p_id, project]);

    const getEmployeeInvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceEmployee/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const data = res.data;
            const data2 = response2.data;


            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedEmployeeData = isAnyBoqJsonNull ? data2 : data;
            setEmployees(selectedEmployeeData);
        } catch (err) { }
    };
    const getEmployeeInvoiceDeduction = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoiceemployeefiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setEmployeeDeduction(data);



        } catch (err) { }
    };



    useEffect(() => {
        getEmployeeInvoice();
    }, [p_id, month, year, project, invoice_id]);
    useEffect(() => {
        getEmployeeInvoiceDeduction();
    }, [invoice_id]);

    const [transportations, setTransportations] = useState([]);
    const [transportDeduction, setTransportDeduction] = useState([]);


    const getTransportationInvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceTransoprt/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const data = res.data;
            const data2 = response2.data;

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedTransportationData = isAnyBoqJsonNull ? data2 : data;
            setTransportations(selectedTransportationData);
        } catch (err) { }
    };

    const getTransportDeduction = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoicetransportationfiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setTransportDeduction(data);



        } catch (err) { }
    };
    useEffect(() => {
        getTransportDeduction();
    }, [invoice_id]);


    useEffect(() => {

        // getdocument();
        getTransportationInvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [dutyTravelinvoice, setDutyTravelinvoice] = useState([]);
    const [dutyTravelDeduction, setDutyTravelDeduction] = useState([]);

    const getDutyTravelDeduction = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoicedutytravelfiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setDutyTravelDeduction(data);



        } catch (err) { }
    };
    useEffect(() => {
        getDutyTravelDeduction();
    }, [invoice_id]);


    const getDutyTravelinvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceDutyTravel/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const dutydata = res.data;
            const dutydata2 = response2.data;

            const isBoqJsonNull = dutydata.length !== 0 && dutydata.every(item => item.boq_json === null);

            const selectedDutyData = isBoqJsonNull ? dutydata2 : dutydata;

            setDutyTravelinvoice(selectedDutyData);
        } catch (err) { }
    };




    useEffect(() => {

        // getdocument();
        getDutyTravelinvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [officeRentinvoice, setOfficeRentinvoice] = useState([]);
    const [officeRentlDeduction, setofficeRentlDeduction] = useState([]);

    const getofficeRentlDeduction = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoiceofficerentfiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setofficeRentlDeduction(data);



        } catch (err) { }
    };
    useEffect(() => {
        getofficeRentlDeduction();
    }, [invoice_id]);

    const getOfficeRentinvoice = async () => {

        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceOfficeRent/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const data = res.data;
            const data2 = response2.data;

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedTransportationData = isAnyBoqJsonNull ? data2 : data;
            setOfficeRentinvoice(selectedTransportationData);
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getOfficeRentinvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [officeSuppliesinvoice, setOfficeSuppliesinvoice] = useState([]);
    const [officeSupplieslDeduction, setofficeSupplieslDeduction] = useState([]);

    const getofficeSupplieslDeduction = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoiceofficesuppliesfiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setofficeSupplieslDeduction(data);



        } catch (err) { }
    };
    useEffect(() => {
        getofficeSupplieslDeduction();
    }, [invoice_id]);


    const getOfficeSuppliesinvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceOfficeSupplies/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const data = res.data;
            const data2 = response2.data;

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedData = isAnyBoqJsonNull ? data2 : data;
            setOfficeSuppliesinvoice(selectedData);
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getOfficeSuppliesinvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const [officeFurnitureinvoice, setOfficeFurnitureinvoice] = useState([]);
    const [officefurnitureDeduction, setofficefurnitureDeduction] = useState([]);

    const getofficefurnitureDeduction = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setofficefurnitureDeduction(data);



        } catch (err) { }
    };
    useEffect(() => {
        getofficefurnitureDeduction();
    }, [invoice_id]);


    const getOfficeFurnitureinvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceOfficeFurnitureAndEquipment/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const data = res.data;
            const data2 = response2.data;

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.invoice_amount === null);


            const selectedData = isAnyBoqJsonNull ? data2 : data;
            setOfficeFurnitureinvoice(selectedData);
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getOfficeFurnitureinvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [reportsPrinttinvoice, setReportsPrinttinvoice] = useState([]);
    const [reportsAndDocumentsDeduction, setreportsAndDocumentsDeduction] = useState([]);

    const getreportsAndDocumentsDeduction = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setreportsAndDocumentsDeduction(data);



        } catch (err) { }
    };
    useEffect(() => {
        getreportsAndDocumentsDeduction();
    }, [invoice_id]);
    const getReportsPrinttinvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceReportsAndDocumentPrinting/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const data = res.data;
            const data2 = response2.data;

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedData = isAnyBoqJsonNull ? data2 : data;
            setReportsPrinttinvoice(selectedData);
        } catch (err) { }
    };




    useEffect(() => {

        // getdocument();
        getReportsPrinttinvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [roadSurveyinvoice, setRoadSurveyinvoice] = useState([]);
    const [roadSurveyDeductions, setroadSurveyDeductions] = useState([]);

    const getroadSurveyDeductions = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfiltermonthyear/${invoice_id}/null/null/`
            );
            const data = res.data;
            setroadSurveyDeductions(data);



        } catch (err) { }
    };
    useEffect(() => {
        getroadSurveyDeductions();
    }, [invoice_id]);

    const getRoadSurveyinvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id ? p_id : project}/${month}/${year}/`);
            const response2 = await axios.get(
                `${BASE_URL}/siteproject/oldlogInvoiceRoadSurveyEquipment/${p_id ? p_id : project}/${month}/null/${invoice_id}/null/`
            );
            const data = res.data;
            const data2 = response2.data;

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedData = isAnyBoqJsonNull ? data2 : data;
            setRoadSurveyinvoice(selectedData);
        } catch (err) { }
    };


    const [contigency, setContigency] = useState([]);

    const getContigency = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoicecontingenciesbyproject/${p_id ? p_id : project}/`
            );
            setContigency(res.data);
        } catch (err) {
            console.error("Error fetching consultant invoice data:", err);
        }
    };

    useEffect(() => {
        getContigency();

    }, [p_id, project]);

    useEffect(() => {

        // getdocument();
        getRoadSurveyinvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [calculateEmployeeTotal, setEmployeeTotal] = useState(0);
    const [calculateEmployeeTotalSub, setEmployeeTotalSub] = useState(0);
    const [calculateEmployeeTotalSupport, setEmployeeTotalSupport] = useState(0);
    const [calculateEmployeeTotalDeductions, setEmployeeTotalDeductions] = useState(0);
    const [calculateEmployeeTotalDeductionsSub, setEmployeeTotalDeductionsSub] = useState(0);
    const [calculateEmployeeTotalDeductionsSupport, setEmployeeTotalDeductionsSupport] = useState(0);


    useEffect(() => {
        const filterKeyprof = employees.filter(item => item?.employee_details?.professional_type === "Key Professional")
        const filterSubprof = employees.filter(item => item?.employee_details?.professional_type === "Sub Professional")
        const filterSupport = employees.filter(item => item?.employee_details?.professional_type === "Support Staff")

        const calculateCurrentAmount = calculateTotal(
            filterKeyprof,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        const calculateCurrentAmountSub = calculateTotal(
            filterSubprof,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        const calculateCurrentAmountSupport = calculateTotal(
            filterSupport,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setEmployeeTotal(calculateCurrentAmount);
        setEmployeeTotalSub(calculateCurrentAmountSub);
        setEmployeeTotalSupport(calculateCurrentAmountSupport);
    }, [employees]);
    useEffect(() => {
        const filterKeyprof = employeeDeduction.filter(item => item?.employee_details?.professional_type === "Key Professional")
        const filterSubprof = employeeDeduction.filter(item => item?.employee_details?.professional_type === "Sub Professional")
        const filterSupport = employeeDeduction.filter(item => item?.employee_details?.professional_type === "Support Staff")

        const calculateCurrentAmount = calculateTotal(
            filterKeyprof,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        const calculateCurrentAmountSub = calculateTotal(
            filterSubprof,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        const calculateCurrentAmountSupport = calculateTotal(
            filterSupport,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setEmployeeTotalDeductions(calculateCurrentAmount);
        setEmployeeTotalDeductionsSub(calculateCurrentAmountSub);
        setEmployeeTotalDeductionsSupport(calculateCurrentAmountSupport);
    }, [employeeDeduction]);
    const [calculatetransport, settransportTotal] = useState(0);
    const [calculatetransportDeductions, settransportTotalDeductions] = useState(0);


    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            transportations,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        settransportTotal(calculateCurrentAmount);
    }, [transportations]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            transportDeduction,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        settransportTotalDeductions(calculateCurrentAmount);
    }, [transportDeduction]);


    const [calculateDuty, setCalculateDuty] = useState(0);
    const [calculateDutyDeductions, setCalculateDutyDeductions] = useState(0);

    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            dutyTravelDeduction,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateDutyDeductions(calculateCurrentAmount);
    }, [dutyTravelDeduction]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            dutyTravelinvoice,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateDuty(calculateCurrentAmount);
    }, [dutyTravelinvoice]);


    const [calculateRent, setCalculaterent] = useState(0);
    const [calculateRentDeductions, setCalculaterentDeductions] = useState(0);

    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            officeRentlDeduction,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculaterentDeductions(calculateCurrentAmount);
    }, [officeRentlDeduction]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            officeRentinvoice,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculaterent(calculateCurrentAmount);
    }, [officeRentinvoice]);

    const [calculateSupplies, setCalculatesupplies] = useState(0);
    const [calculateSuppliesDeductions, setCalculatesuppliesDeductions] = useState(0);


    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            officeSuppliesinvoice,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculatesupplies(calculateCurrentAmount);
    }, [officeSuppliesinvoice]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            officeSupplieslDeduction,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculatesuppliesDeductions(calculateCurrentAmount);
    }, [officeSupplieslDeduction]);


    const [calculateFurniture, setCalculateFurniture] = useState(0)
    const [calculateFurnitureDeductions, setCalculateFurnitureDeductions] = useState(0)

    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            officeFurnitureinvoice,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateFurniture(calculateCurrentAmount);
    }, [officeFurnitureinvoice]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            officefurnitureDeduction,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateFurnitureDeductions(calculateCurrentAmount);
    }, [officefurnitureDeduction]);


    const [calculateReports, setCalculateReports] = useState(0)
    const [calculateReportsDeductions, setCalculateReportsDeductions] = useState(0)

    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            reportsPrinttinvoice,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateReports(calculateCurrentAmount);
    }, [reportsPrinttinvoice]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            reportsAndDocumentsDeduction,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateReportsDeductions(calculateCurrentAmount);
    }, [reportsAndDocumentsDeduction]);


    const [calculateRoadsurvey, setCalculateRoadSurvey] = useState(0);
    const [calculateRoadsurveyDeductions, setCalculateRoadSurveyDeductions] = useState(0);


    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            roadSurveyinvoice,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateRoadSurvey(calculateCurrentAmount);
    }, [roadSurveyinvoice]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            roadSurveyDeductions,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setCalculateRoadSurveyDeductions(calculateCurrentAmount);
    }, [roadSurveyDeductions]);


    const [calculatecintigeniousTotal, setContigeneousTotal] = useState(0);

    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            contigency,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        setContigeneousTotal(calculateCurrentAmount);
    }, [contigency]);
    useEffect(() => {
        const calculateCurrentAmount = calculateTotal(
            transportations,
            (item) => Number(item.invoice_amount ?? item.current_invoice_amount)
        );
        settransportTotal(calculateCurrentAmount);
    }, [transportations]);



    const [paymentData, setPaymentData] = useState();
    const [deductionData, setDeductionData] = useState([]);

    const [deductionPaymentData, setDeductionPAymentData] = useState([]);



    const projectId = sessionStorage.getItem('sitemanagement_project');


    const [releaseDataByProject, setreleaseDataByProject] = useState([]);





    const getPaymentDeductionData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/null/${invoice_id}/null/`);
            setDeductionPAymentData(res.data);
        } catch (error) {
            console.error(error);

        }
    }
    const getOtherDeductionData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release-by-invoice/${invoice_id}/`);
            setDeductionData(res.data);
        } catch (error) {
            console.error(error);

        }
    }
    const getReleaseByProject = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
            setreleaseDataByProject(res.data);
        } catch (error) {
            console.error(error);

        }
    }

    const getPayment = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/paymentrecievedfilter/${p_id ? p_id : projectId}/${month}/${year}/${invoice_num}/`);
            setPaymentData(res.data[0]);

        } catch (err) { }
    };



    useEffect(() => {

        // getdocument();
        getPayment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [p_id, projectId, month, year, invoice_num, invoice_id]);

    useEffect(() => {

        getOtherDeductionData();
        getPaymentDeductionData();
        getReleaseByProject();
    }, []);


    const filterDeductionData = deductionPaymentData.filter(i => i.item_id === null || i.item_id === "null" || i.item_id === undefined);
    const getDeductionIds = filterDeductionData.map(i => i.id);

    const filterReleaseIds = deductionData.map(i => i.id);

    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const navigate = useNavigate();

    const ViewInvoiceDeduction = (invoice_id, month, invoice_number, year) => {
        navigate(`/${urlParts[3]}/ConsultancyInvoiceDeductions/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
    };
    const ViewInvoice = (invoice_id, month, invoice_number, year) => {
        navigate(`/${urlParts[3]}/ConsultancyInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
    };
    const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
        navigate(`/${urlParts[3]}/PrintInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
    };


    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }} ref={ref}>
            <div className="boc-modern-card">

                {/* Print header */}
                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectbyid?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectbyid?.client_name}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectbyid?.lead}{projectbyid?.jv ? ` JV with ${projectbyid?.jv}.` : ""}{projectbyid?.association ? ` Association with ${projectbyid?.association}` : ""}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectbyid?.gst_no}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectbyid?.pan_no}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectbyid?.bid_due_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectbyid?.agreement_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectbyid?.commencement_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section heading + action */}
                <div className="boc-modern-description-section">
                    <div className="boc-modern-controls flex-row">
                        <div className="boc-modern-controls-left">
                            <h6 className="boc-modern-main-heading">Payment Receipt</h6>
                        </div>
                        <div className="flex-row hide-on-print" style={{ gap: "10px", alignItems: "center" }}>
                            <div className='form-field flex-row'>

                                <button
                                    className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                                    onClick={() => ViewInvoiceDeduction(invoice_id, month, invoice_num, year)}
                                    title="View Invoice Deduction Details"
                                >
                                    <FileText size={18} color="#fff" /><label style={{ color: "white" }}>View Deduction Invoice</label>

                                </button>
                                <button
                                    className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                                    onClick={() => ViewInvoice(invoice_id, month, invoice_num, year)}
                                    title="View Invoice Details"
                                >
                                    <FileText size={18} color="#fff" /><label style={{ color: "white" }}>View Raised Invoice</label>

                                </button>
                            </div>

                            {!paymentData || Object.keys(paymentData).length === 0 ? (
                                <div className="hide-on-print">
                                    <AddPaymentReceipt
                                        p_id={p_id}
                                        invoice_num={invoice_num}
                                        invoice_id={invoice_id}
                                        getPayment={getPayment}
                                        project_id={projectId}
                                        month={month}
                                        year={year}
                                        releaseByProject={releaseDataByProject}
                                        calculateCurrentAmountSupport={calculateEmployeeTotalSupport}
                                        calculateCurrentAmountSub={calculateEmployeeTotalSub}
                                        calculateTotalEmployee={calculateEmployeeTotal}
                                        calculateTotaltransport={calculatetransport}
                                        calculateTotalDuty={calculateDuty}
                                        calculateTotalRent={calculateRent}
                                        calculateTotalSupplies={calculateSupplies}
                                        calculateTotalReports={calculateReports}
                                        calculatetotalFurniture={calculateFurniture}
                                        calculateTotalSurevy={calculateRoadsurvey}
                                        calculateCurrentAmountSupportDeductions={calculateEmployeeTotalDeductionsSupport}
                                        calculateCurrentAmountSubDeductions={calculateEmployeeTotalDeductionsSub}
                                        calculateTotalEmployeeDeductions={calculateEmployeeTotalDeductions}
                                        calculateTotaltransportDeductions={calculatetransportDeductions}
                                        calculateTotalDutyDeductions={calculateDutyDeductions}
                                        calculateTotalRentDeductions={calculateRentDeductions}
                                        calculateTotalSuppliesDeductions={calculateSuppliesDeductions}
                                        calculateTotalReportsDeductions={calculateReportsDeductions}
                                        calculatetotalFurnitureDeductions={calculateFurnitureDeductions}
                                        calculateTotalSurevyDeductions={calculateRoadsurveyDeductions}
                                    />
                                </div>
                            ) : (
                                <>
                                    {(!["Checker", "SiteManagement"].includes(role) && true) ||
                                        (role === "Checker" && !isMoreThan24Hours(paymentData.created_at)) ? (
                                        <div className="hide-on-print">
                                            <DeletePaymentrecipt i={paymentData?.id} getPaymentReceipt={getPayment} deductionData={deductionData} deductionIds={getDeductionIds} releaseIds={filterReleaseIds} />
                                        </div>
                                    ) : (
                                        <div className="boc-modern-td hide-on-print">
                                            Delete Button hides after 24 hrs
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" style={{ width: "10vw" }}>S.No</th>
                                    <th className="boc-modern-th text-center" style={{ width: "20vw" }}>Particulars</th>
                                    <th className="boc-modern-th text-center" style={{ width: "10vw" }}>Invoice Amount</th>
                                    <th className="boc-modern-th text-center" style={{ width: "10vw" }}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <React.Fragment>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">1</td>
                                        <td className="boc-modern-td text-left">Remuneration for Local Professional Staff</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculateEmployeeTotal || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.local_professional_staff)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">2</td>
                                        <td className="boc-modern-td text-left">Transportation</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculatetransport || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.transport)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">3</td>
                                        <td className="boc-modern-td text-left">Duty Travels</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculateDuty || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.duty_travel)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">4</td>
                                        <td className="boc-modern-td text-left">Office Rent</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculateRent || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.office_rent)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">5</td>
                                        <td className="boc-modern-td text-left">Office Supplies, Utilities and Communications</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculateSupplies || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.office_supplies)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">6</td>
                                        <td className="boc-modern-td text-left">Office Furniture and Equipments</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculateFurniture || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.office_furniture)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">7</td>
                                        <td className="boc-modern-td text-left">Report and Document Printing</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculateReports || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.reports)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">8</td>
                                        <td className="boc-modern-td text-left">Road Survey Equipment</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(calculateRoadsurvey || 0)}</td>
                                        <td className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.road_survey)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td className="boc-modern-td">9</td>
                                        <td className="boc-modern-td text-left">Contingencies</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.contingencies)}</td>
                                    </tr>
                                    {deductionData
                                        .filter(i => i.escalation_percentage === "")
                                        .map((i, index) => (
                                            <tr className="boc-modern-row" key={index}>
                                                <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>{i.description}</td>
                                                <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(i.deduction_amount ? i.deduction_amount : i.withheld_release_amount)}</td>
                                            </tr>
                                        ))
                                    }
                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left">Sub Total(A)</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.total_bill_without_escalation)}</td>
                                    </tr>

                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left">Add: Escalation ({Number(paymentData?.escalation_percentage ? paymentData?.escalation_percentage : "0")?.toFixed(0)}% of Subtotal)</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.escalation_amount)}</td>
                                    </tr>
                                    {deductionData
                                        .filter(i => i.escalation_percentage)
                                        .map((i, index) => (
                                            <tr className="boc-modern-row" key={index}>
                                                <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>{i.description}</td>
                                                <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(i.deduction_amount ? i.deduction_amount : i.withheld_release_amount)}</td>
                                            </tr>
                                        ))
                                    }
                                    {deductionPaymentData
                                        .filter(i => i.item_id === null && i.invoice_type === "deduction")
                                        .map((i, index) => (
                                            <tr className="boc-modern-row" key={index}>
                                                <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>{i.deduction_reason}</td>
                                                <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(i.deduction_amount)}</td>
                                            </tr>
                                        ))
                                    }
                                    {deductionPaymentData
                                        .filter(i => i.item_id === null && i.invoice_type === "withheldDeduction")
                                        .map((i, index) => (
                                            <tr className="boc-modern-row" key={index}>
                                                <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>{i.withheld_deduction_reason}</td>
                                                <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(i.withheld_deduction_amount)}</td>
                                            </tr>
                                        ))
                                    }

                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>Net Amount</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.net_ammount)}</td>
                                    </tr>

                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left">Add GST @{paymentData?.gst_18_percentage ? paymentData?.gst_18_percentage : "0"}%</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.gst_amount)}</td>
                                    </tr>

                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>Gross Bill Amount (B)</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.gross_bill_ammount_B)}</td>
                                    </tr>

                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>Deductions:</td>
                                        <td colSpan="2" className="boc-modern-td"></td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left">TDS deducted @{paymentData?.tds_it_percentage ? paymentData?.tds_it_percentage : "0"}%</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.tds_it_amount)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left">GST (TDS) @{paymentData?.gst_tds_2_percentage ? paymentData?.gst_tds_2_percentage : "0"}%</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.tds_gst_amount)}</td>
                                    </tr>
                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left">GST Withheld due to Non Submission of Proof</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.withheld_gst_amount)}</td>
                                    </tr>
                                    {deductionData
                                        .filter(i => i.withheld_deduction_heading?.trim() && i.withheld_deduction_amt)
                                        .map((i, index) => (
                                            <tr className="boc-modern-row" key={index}>
                                                <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>{i.withheld_deduction_heading}</td>
                                                <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(i.withheld_deduction_amt)}</td>
                                            </tr>
                                        ))
                                    }
                                    <tr className="boc-modern-row">
                                        <td colSpan="2" className="boc-modern-td text-left">Total Deductions</td>
                                        <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(paymentData?.total_deduction)}</td>
                                    </tr>
                                    {releaseDataByProject
                                        .filter(i => i.deduction_data?.item_id === null)
                                        .map((i, index) => (
                                            <tr className="boc-modern-row" key={index}>
                                                <td colSpan="2" className="boc-modern-td text-left" style={{ fontWeight: 600 }}>{i.description}</td>
                                                <td colSpan="2" className="boc-modern-td boc-modern-currency text-right">{formatCurrencyIndian(i.deduction_amount || i.withheld_release_amount)}</td>
                                            </tr>
                                        ))
                                    }
                                    <tr className="boc-modern-footer">
                                        <td colSpan="2" className="boc-modern-footer-label">Net Payable Amount</td>
                                        <td colSpan="2" className="boc-modern-td text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">{formatCurrencyIndian(paymentData?.net_payable_amount)}</span>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};



export { AddPaymentReceipt, PaymentReceipt }